$(function() {
  mobileMenuInit();
  hoverProductCardImage();
  initJscProductCardSwatchInteractions();
  productCardCustomScrollbarInit();
  productCardDesktopDragScrollInit();
  productCardAdditionalImagesArrowsInit();
  initJscProductGalleryChrome();
  initJscPdpMobileScroll();
  initJscPdpMobileColorHeadOrder();
  initJscPdpSizeRequiredAtc();
  initJscFooterWideLayout();
  initJscFooterMobileAccordion();
  initJscProductDrawerGallery();
  initJscCartSummaryCollapse();
  initJscCartDrawerRemoveFix();
  initJscSlideshowScrollArrow();
});

/**
 * Slideshow "arrow down" scrolls to the next section without changing the URL.
 * Resolves the target by exact ID, section-key suffix, or next sibling section.
 */
initJscSlideshowScrollArrow = function () {
  if (initJscSlideshowScrollArrow._bound) return;
  initJscSlideshowScrollArrow._bound = true;

  function resolveScrollTarget(arrow) {
    var targetId = arrow.getAttribute('data-jsc-scroll-target');
    var target = targetId ? document.getElementById(targetId) : null;

    // Theme IDs differ between live and preview; match by section key suffix.
    if (!target && targetId) {
      var keyMatch = targetId.match(/__(.+)$/);
      if (keyMatch) {
        target = document.querySelector('[id$="__' + keyMatch[1] + '"]');
      }
    }

    // Fallback: scroll to the next Shopify section after this slideshow.
    if (!target) {
      var currentSection = arrow.closest('.shopify-section');
      if (currentSection) {
        var next = currentSection.nextElementSibling;
        while (next && !next.classList.contains('shopify-section')) {
          next = next.nextElementSibling;
        }
        target = next;
      }
    }

    return target;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.jsc-slideshow-arrow');
    if (!arrow) return;

    event.preventDefault();
    var target = resolveScrollTarget(arrow);
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
};

/**
 * Cart drawer line removal (app.js CartDrawer#removeProductEvent).
 * Theme version reads event.target (the trash <img>, not the link) and re-binds on
 * every call, so one click could fire several removals. Bind once per row via currentTarget.
 */
initJscCartDrawerRemoveFix = function () {
  if (initJscCartDrawerRemoveFix._bound) return;
  initJscCartDrawerRemoveFix._bound = true;
  if (!window.customElements || typeof customElements.whenDefined !== 'function') return;

  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawerElement = customElements.get('cart-drawer');
    if (!CartDrawerElement) return;

    CartDrawerElement.prototype.removeProductEvent = function () {
      var self = this;
      this.querySelectorAll('.remove').forEach(function (remove) {
        // Bundle/PWP rows remove via their own onclick and carry no line index.
        if (!remove.dataset.index || remove.dataset.jscRemoveBound === 'true') return;
        // Swapping in a copy drops listeners already attached, so a click can only fire one removal.
        var row = remove.cloneNode(true);
        row.dataset.jscRemoveBound = 'true';
        remove.parentNode.replaceChild(row, remove);
        row.addEventListener('click', function (event) {
          event.preventDefault();
          self.updateQuantity(event.currentTarget.dataset.index, '0');
        });
      });
    };

    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
  });
};

initJscCartSummaryCollapse = function () {
  if (initJscCartSummaryCollapse._bound) return;
  initJscCartSummaryCollapse._bound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-summary-collapsible');
    if (!btn) return;
    var panelId = btn.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : btn.parentElement.querySelector('.cart-summary-content-amount');
    if (!panel) return;
    var expanded = btn.getAttribute('aria-expanded') !== 'false';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.classList.toggle('is-collapsed', expanded);
  });
};

mobileMenuInit = () => {
  const DRAWER = document.querySelector('#mobile-menu.jsc-mobile-menu');
  if (!DRAWER) return;

  let activePanel = null;
  let activeOpenButton = null;

  function closeL2() {
    DRAWER.classList.remove('jsc-mobile-menu--l2-open');
    const mega = DRAWER.querySelector('.jsc-mobile-menu__mega');
    if (mega) mega.classList.remove('jsc-mobile-menu__mega--l2-open');
    if (!activePanel) return;
    const rootId = activePanel.getAttribute('data-jsc-mm-root-panel');
    const rootUl = rootId ? document.getElementById(rootId) : null;
    activePanel.setAttribute('hidden', '');
    if (rootUl) {
      rootUl.classList.remove('jsc-mobile-menu__root-panel--drill-hidden');
      rootUl.removeAttribute('aria-hidden');
    }
    if (activeOpenButton) {
      activeOpenButton.setAttribute('aria-expanded', 'false');
    }
    activePanel = null;
    activeOpenButton = null;
  }

  function openL2(panel, openButton) {
    closeL2();
    const rootId = panel.getAttribute('data-jsc-mm-root-panel');
    const rootUl = rootId ? document.getElementById(rootId) : null;
    if (!rootUl) return;
    activePanel = panel;
    activeOpenButton = openButton;
    rootUl.classList.add('jsc-mobile-menu__root-panel--drill-hidden');
    rootUl.setAttribute('aria-hidden', 'true');
    panel.removeAttribute('hidden');
    openButton.setAttribute('aria-expanded', 'true');
    DRAWER.classList.add('jsc-mobile-menu--l2-open');
    const mega = DRAWER.querySelector('.jsc-mobile-menu__mega');
    if (mega) mega.classList.add('jsc-mobile-menu__mega--l2-open');
    if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
      panel.querySelectorAll('img.lazyload').forEach(function (img) {
        lazySizes.loader.unveil(img);
      });
    }
    const back = panel.querySelector('[data-jsc-mobile-l2-back]');
    if (back) {
      back.focus({ preventScroll: true });
    }
  }

  DRAWER.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-jsc-mobile-open-l2]');
    if (openBtn) {
      e.preventDefault();
      const sel = openBtn.getAttribute('data-jsc-mobile-open-l2');
      const panel = sel ? document.querySelector(sel) : null;
      if (panel && panel.hasAttribute('data-jsc-mobile-l2-panel')) {
        openL2(panel, openBtn);
      }
      return;
    }

    const backBtn = e.target.closest('[data-jsc-mobile-l2-back]');
    if (backBtn) {
      e.preventDefault();
      const opener = activeOpenButton;
      closeL2();
      if (opener && DRAWER.contains(opener)) {
        opener.focus({ preventScroll: true });
      }
    }
  });

  DRAWER.querySelectorAll('.jsc-mobile-menu__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      closeL2();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !activePanel) return;
    const toggle = document.querySelector('.mobile-toggle-wrapper.active');
    if (!toggle) return;
    const opener = activeOpenButton;
    closeL2();
    if (opener && DRAWER.contains(opener)) {
      opener.focus({ preventScroll: true });
    }
  });

  const toggle = document.querySelector('.mobile-toggle-wrapper');
  if (toggle) {
    const observer = new MutationObserver(function () {
      if (!toggle.classList.contains('active')) {
        closeL2();
      }
    });
    observer.observe(toggle, { attributes: true, attributeFilter: ['class'] });
  }
};

sectionPaginationInit = () => {
  const DESKTOP_BREAKPOINT = 1024;
  const paginationElements = document.querySelectorAll('.jsc-section-pagination');

  if (!paginationElements.length) return;

  const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

  paginationElements.forEach(function (paginationEl) {
    if (paginationEl.dataset.jscPaginationInit === 'true') {
      const prevIcon = paginationEl.querySelector('.jsc-section-pagination__arrow--prev img');
      const nextIcon = paginationEl.querySelector('.jsc-section-pagination__arrow--next img');
      if (prevIcon && paginationEl.dataset.prevIcon) prevIcon.src = paginationEl.dataset.prevIcon;
      if (nextIcon && paginationEl.dataset.nextIcon) nextIcon.src = paginationEl.dataset.nextIcon;
      if (paginationEl.jscPaginationRefresh) {
        paginationEl.jscPaginationRefresh();
      }
      return;
    }

    const sectionContainer = paginationEl.closest('.list-collections, .featured-collection, .product-recommendations');
    if (!sectionContainer) return;

    const scrollContainer = sectionContainer.querySelector('theme-scroll.jsc-hide-default-scrollbar');
    const viewport = scrollContainer ? scrollContainer.querySelector('.theme-scroll--inner') : null;
    if (!viewport) return;

    const desktopColumns = Math.max(1, parseInt(paginationEl.dataset.desktopColumn, 10) || 1);
    const fallbackTotalItems = sectionContainer.querySelectorAll('.carousel__slide').length;

    let totalItems = parseInt(paginationEl.dataset.totalColumn, 10);
    if (!Number.isFinite(totalItems) || totalItems < 1) {
      totalItems = Math.max(1, fallbackTotalItems);
    }

    // 'items' counts every card slot ("1/5"); 'pages' counts viewport-fulls ("1/2").
    const countsItems = paginationEl.dataset.paginationMode === 'items';
    const totalSteps = countsItems
      ? totalItems
      : Math.max(1, Math.ceil(totalItems / desktopColumns));

    paginationEl.textContent = '';

    const prevButton = document.createElement('button');
    prevButton.type = 'button';
    prevButton.className = 'jsc-section-pagination__arrow jsc-section-pagination__arrow--prev';
    prevButton.setAttribute('aria-label', 'Previous page');
    const prevIcon = document.createElement('img');
    prevIcon.src = paginationEl.dataset.prevIcon;
    prevIcon.alt = '';
    prevIcon.setAttribute('aria-hidden', 'true');
    prevButton.append(prevIcon);

    const counter = document.createElement('span');
    counter.className = 'jsc-section-pagination__counter';

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'jsc-section-pagination__arrow jsc-section-pagination__arrow--next';
    nextButton.setAttribute('aria-label', 'Next page');
    const nextIcon = document.createElement('img');
    nextIcon.src = paginationEl.dataset.nextIcon;
    nextIcon.alt = '';
    nextIcon.setAttribute('aria-hidden', 'true');
    nextButton.append(nextIcon);

    paginationEl.append(prevButton, counter, nextButton);

    const slides = Array.prototype.slice.call(viewport.querySelectorAll('.carousel__slide'));
    const loops = paginationEl.dataset.paginationLoop === 'true' && slides.length > 1;
    // Position in `slides` of the card currently occupying the first visible slot.
    let firstSlot = 0;
    let animating = false;

    const getMaxScrollLeft = function () {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    };

    // Distance between two adjacent card origins, i.e. card width plus column gap.
    // Measured from one card rather than two so it survives CSS order shuffling.
    const getSlidePitch = function () {
      if (!slides.length) return 0;
      const width = slides[0].getBoundingClientRect().width;
      if (width <= 0) return 0;
      return width + (parseFloat(window.getComputedStyle(viewport).columnGap) || 0);
    };

    const getPageStep = function () {
      if (totalSteps <= 1) return 0;
      const maxScrollLeft = getMaxScrollLeft();
      if (maxScrollLeft <= 0) return 0;
      if (countsItems) {
        return getSlidePitch() || maxScrollLeft / (totalSteps - 1);
      }
      return maxScrollLeft / (totalSteps - 1);
    };

    const getCurrentPage = function () {
      const pageStep = getPageStep();
      if (pageStep <= 0) return 1;
      return Math.min(totalSteps, Math.max(1, Math.round(viewport.scrollLeft / pageStep) + 1));
    };

    const isAtEnd = function () {
      return viewport.scrollLeft >= getMaxScrollLeft() - 1;
    };

    // Rotating the grid order, rather than moving nodes, keeps the card that
    // should lead in the first slot without disturbing the DOM.
    const applySlotOrder = function () {
      slides.forEach(function (slide, index) {
        slide.style.order = (index - firstSlot + slides.length) % slides.length;
      });
    };

    const resetSlotOrder = function () {
      firstSlot = 0;
      slides.forEach(function (slide) {
        slide.style.order = '';
      });
    };

    // A loop step only lands cleanly while the track can scroll a full card past
    // the first slot; without that headroom fall back to clamped scrolling.
    const canLoop = function () {
      const pitch = getSlidePitch();
      return loops && isDesktop() && pitch > 0 && getMaxScrollLeft() >= pitch - 1;
    };

    const getCurrentSlot = function () {
      const pitch = getSlidePitch();
      const scrolled = pitch > 0 ? Math.round(viewport.scrollLeft / pitch) : 0;
      const slot = (firstSlot + scrolled) % slides.length;
      return (slot + slides.length) % slides.length + 1;
    };

    const updatePaginationUi = function () {
      if (!isDesktop() && firstSlot !== 0) {
        resetSlotOrder();
        viewport.scrollTo({ left: 0, behavior: 'instant' });
      }

      if (canLoop()) {
        paginationEl.style.display = '';
        counter.textContent = getCurrentSlot() + '/' + slides.length;
        prevButton.disabled = false;
        nextButton.disabled = false;
        return;
      }

      const hasScrollableWidth = getPageStep() > 0;
      paginationEl.style.display = hasScrollableWidth ? '' : 'none';
      if (!hasScrollableWidth) {
        return;
      }
      const currentPage = getCurrentPage();
      counter.textContent = currentPage + '/' + totalSteps;
      prevButton.disabled = !isDesktop() || currentPage <= 1;
      nextButton.disabled = !isDesktop() || currentPage >= totalSteps || isAtEnd();
    };

    const whenScrollSettles = function (target, done) {
      const deadline = window.performance.now() + 900;
      const poll = function () {
        if (Math.abs(viewport.scrollLeft - target) <= 1 || window.performance.now() > deadline) {
          done();
          return;
        }
        window.requestAnimationFrame(poll);
      };
      window.requestAnimationFrame(poll);
    };

    // Slide one card to the left, then re-seat the track at offset 0 with the
    // order rotated. Both frames show the same cards, so the swap is invisible.
    const loopNext = function () {
      const pitch = getSlidePitch();
      animating = true;
      viewport.scrollTo({ left: pitch, behavior: 'smooth' });
      whenScrollSettles(pitch, function () {
        firstSlot = (firstSlot + 1) % slides.length;
        applySlotOrder();
        viewport.scrollTo({ left: 0, behavior: 'instant' });
        animating = false;
        updatePaginationUi();
      });
    };

    // The mirror image: pull the previous card into the first slot and hold the
    // current frame at offset pitch, then animate back to 0.
    const loopPrev = function () {
      const pitch = getSlidePitch();
      animating = true;
      firstSlot = (firstSlot - 1 + slides.length) % slides.length;
      applySlotOrder();
      viewport.scrollTo({ left: pitch, behavior: 'instant' });
      window.requestAnimationFrame(function () {
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
        whenScrollSettles(0, function () {
          animating = false;
          updatePaginationUi();
        });
      });
    };

    // Trackpad scrolling bypasses the arrows, so fold any drift back into
    // `firstSlot` once it stops.
    const realignAfterUserScroll = function () {
      if (animating || !canLoop()) return;
      const pitch = getSlidePitch();
      const steps = Math.round(viewport.scrollLeft / pitch);
      if (!steps) return;
      firstSlot = ((firstSlot + steps) % slides.length + slides.length) % slides.length;
      applySlotOrder();
      viewport.scrollTo({ left: 0, behavior: 'instant' });
      updatePaginationUi();
    };

    // Step from the actual scroll offset rather than the counter, so a clamped
    // final position still steps back onto the previous aligned slot.
    const scrollByStep = function (direction) {
      if (!isDesktop()) return;
      const pageStep = getPageStep();
      if (pageStep <= 0) return;

      const TOLERANCE = 1;
      const offset = viewport.scrollLeft;
      const target = direction > 0
        ? Math.floor((offset + TOLERANCE) / pageStep) + 1
        : Math.ceil((offset - TOLERANCE) / pageStep) - 1;

      viewport.scrollTo({
        left: Math.min(Math.max(0, target) * pageStep, getMaxScrollLeft()),
        behavior: 'smooth'
      });
    };

    prevButton.addEventListener('click', function () {
      if (animating) return;
      if (canLoop()) {
        loopPrev();
        return;
      }
      scrollByStep(-1);
    });

    nextButton.addEventListener('click', function () {
      if (animating) return;
      if (canLoop()) {
        loopNext();
        return;
      }
      scrollByStep(1);
    });

    let frameRequested = false;
    let realignTimer;
    viewport.addEventListener('scroll', function () {
      window.clearTimeout(realignTimer);
      realignTimer = window.setTimeout(realignAfterUserScroll, 150);
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(function () {
        updatePaginationUi();
        frameRequested = false;
      });
    }, { passive: true });

    window.addEventListener('resize', updatePaginationUi);

    paginationEl.jscPaginationRefresh = updatePaginationUi;
    paginationEl.dataset.jscPaginationInit = 'true';
    updatePaginationUi();
  });
};

sectionPaginationInit();
document.addEventListener('shopify:section:load', function () {
  sectionPaginationInit();
  hoverProductCardImage();
  productCardCustomScrollbarInit();
  productCardDesktopDragScrollInit();
  productCardAdditionalImagesArrowsInit();
  initJscPdpMobileScroll();
  initJscFooterWideLayout();
  initJscFooterMobileAccordion();
});
document.addEventListener('pagination:page-changed', function () {
  hoverProductCardImage();
  productCardCustomScrollbarInit();
  productCardDesktopDragScrollInit();
  productCardAdditionalImagesArrowsInit();
});

productCardCustomScrollbarInit = () => {
  const cards = document.querySelectorAll('product-card[data-additional-images-scrolling="scrollbar"]');
  if (!cards.length) return;

  cards.forEach((card) => {
    const slider = card.querySelector('.product-card--image');
    const viewport = card.querySelector('.product-card--image-inner');
    const wrapper = card.querySelector('.product-card--image-wrapper');

    if (!slider || !viewport || !wrapper) return;

    card.classList.add('jsc-product-card-scrollbar-mode-scrollbar');

    let track = wrapper.querySelector('.jsc-product-card-scrollbar');
    let thumb = track ? track.querySelector('.jsc-product-card-scrollbar__thumb') : null;

    if (!track) {
      track = document.createElement('div');
      track.className = 'jsc-product-card-scrollbar';

      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'jsc-product-card-scrollbar__thumb';
      thumb.setAttribute('aria-label', 'Scroll product images');

      track.appendChild(thumb);
      wrapper.appendChild(track);
    }

    if (card.dataset.jscProductScrollbarInit === 'true') {
      if (card.jscProductScrollbarRefresh) {
        card.jscProductScrollbarRefresh();
      }
      return;
    }

    const getMetrics = function () {
      const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const trackWidth = wrapper.clientWidth;
      const slideCount = Math.max(1, Math.round(slider.scrollWidth / Math.max(slider.clientWidth, 1)));
      const proportional = trackWidth > 0
        ? Math.round((slider.clientWidth / Math.max(slider.scrollWidth, 1)) * trackWidth)
        : 109;
      const isDesktop = window.innerWidth >= 1025;
      const minThumbWidth = isDesktop || slideCount <= 3 ? 109 : 24;
      const thumbWidth = trackWidth > 0
        ? Math.min(trackWidth, Math.max(minThumbWidth, proportional))
        : 109;
      return { maxScroll, trackWidth, thumbWidth };
    };

    const updateThumb = function () {
      const metrics = getMetrics();
      const hasOverflow = metrics.maxScroll > 1 && metrics.trackWidth > 0;
      track.hidden = !hasOverflow;
      if (!hasOverflow) return;

      const thumbMaxOffset = Math.max(0, metrics.trackWidth - metrics.thumbWidth);
      const progress = metrics.maxScroll > 0 ? slider.scrollLeft / metrics.maxScroll : 0;
      const thumbOffset = Math.min(thumbMaxOffset, Math.max(0, progress * thumbMaxOffset));

      thumb.style.width = metrics.thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + thumbOffset + 'px)';
    };

    let rafRequested = false;
    const requestUpdateThumb = function () {
      if (rafRequested) return;
      rafRequested = true;
      window.requestAnimationFrame(function () {
        updateThumb();
        rafRequested = false;
      });
    };

    const scrollToTrackPosition = function (clientX) {
      const metrics = getMetrics();
      if (metrics.maxScroll <= 0 || metrics.trackWidth <= 0) return;

      const rect = track.getBoundingClientRect();
      const thumbHalf = metrics.thumbWidth / 2;
      const clickX = clientX - rect.left - thumbHalf;
      const thumbMaxOffset = Math.max(1, metrics.trackWidth - metrics.thumbWidth);
      const normalizedOffset = Math.min(thumbMaxOffset, Math.max(0, clickX));
      const ratio = normalizedOffset / thumbMaxOffset;
      slider.scrollLeft = ratio * metrics.maxScroll;
    };

    let dragState = null;

    const onPointerMove = function (event) {
      if (!dragState) return;

      const deltaX = event.clientX - dragState.startX;
      const thumbRange = Math.max(1, dragState.trackWidth - dragState.thumbWidth);
      const scrollDelta = (deltaX / thumbRange) * dragState.maxScroll;
      slider.scrollLeft = dragState.startScrollLeft + scrollDelta;
    };

    const onPointerUp = function () {
      dragState = null;
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', onPointerUp);
    };

    thumb.addEventListener('pointerdown', function (event) {
      const metrics = getMetrics();
      if (metrics.maxScroll <= 0) return;

      event.preventDefault();
      dragState = {
        startX: event.clientX,
        startScrollLeft: slider.scrollLeft,
        maxScroll: metrics.maxScroll,
        trackWidth: metrics.trackWidth,
        thumbWidth: metrics.thumbWidth
      };

      thumb.setPointerCapture?.(event.pointerId);
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      document.addEventListener('pointercancel', onPointerUp);
    });

    track.addEventListener('pointerdown', function (event) {
      if (event.target === thumb) return;
      event.preventDefault();
      scrollToTrackPosition(event.clientX);
    });

    slider.addEventListener('scroll', requestUpdateThumb, { passive: true });
    window.addEventListener('resize', requestUpdateThumb);

    const resizeObserver = new ResizeObserver(requestUpdateThumb);
    resizeObserver.observe(slider);
    resizeObserver.observe(viewport);

    viewport.querySelectorAll('img').forEach(function (image) {
      image.addEventListener('load', requestUpdateThumb);
    });

    card.jscProductScrollbarRefresh = requestUpdateThumb;
    card.dataset.jscProductScrollbarInit = 'true';
    requestUpdateThumb();
  });
};

productCardDesktopDragScrollInit = () => {
  const DESKTOP_MIN = 1025;
  const cards = document.querySelectorAll('product-card[data-additional-images-scrolling="scrollbar"][data-enable-desktop-image-drag-scroll="true"]');

  if (!cards.length) return;

  cards.forEach((card) => {
    if (card.dataset.jscDesktopDragScrollInit === 'true') return;

    const slider = card.querySelector('.product-card--image.product-card--image-scroll-mode-scrollbar');
    const imageLink = card.querySelector('.product-card--image-link');

    if (!slider) return;
    card.classList.add('jsc-product-card-drag-enabled');

    let dragState = null;
    let suppressNextClick = false;

    const isDesktop = function () {
      return window.innerWidth >= DESKTOP_MIN;
    };

    const canDrag = function () {
      if (!isDesktop()) return false;
      return slider.scrollWidth - slider.clientWidth > 1;
    };

    const onPointerMove = function (event) {
      if (!dragState) return;

      const deltaX = event.clientX - dragState.startX;
      if (!dragState.hasDragged && Math.abs(deltaX) >= 6) {
        dragState.hasDragged = true;
        card.classList.add('jsc-product-card--dragging');
        slider.classList.add('jsc-is-dragging');
      }

      if (!dragState.hasDragged) return;

      slider.scrollLeft = dragState.startScrollLeft - deltaX;
      event.preventDefault();
    };

    const clearDragState = function () {
      dragState = null;
      card.classList.remove('jsc-product-card--dragging');
      slider.classList.remove('jsc-is-dragging');
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', endDrag);
      document.removeEventListener('pointercancel', endDrag);
    };

    const endDrag = function () {
      if (!dragState) return;
      if (dragState.hasDragged) {
        suppressNextClick = true;
      }
      clearDragState();
    };

    const startDrag = function (event) {
      if (!canDrag()) return;
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;

      if (dragState) return;

      suppressNextClick = false;
      dragState = {
        startX: event.clientX,
        startScrollLeft: slider.scrollLeft,
        hasDragged: false
      };

      document.addEventListener('pointermove', onPointerMove, { passive: false });
      document.addEventListener('pointerup', endDrag);
      document.addEventListener('pointercancel', endDrag);
    };

    slider.addEventListener('pointerdown', startDrag);
    if (imageLink) {
      imageLink.addEventListener('pointerdown', startDrag);
      imageLink.addEventListener('dragstart', function (event) {
        if (canDrag()) {
          event.preventDefault();
        }
      });
    }

    slider.addEventListener('dragstart', function (event) {
      if (canDrag()) {
        event.preventDefault();
      }
    });

    if (imageLink) {
      imageLink.addEventListener('click', function (event) {
        if (!suppressNextClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressNextClick = false;
      });
    }

    card.dataset.jscDesktopDragScrollInit = 'true';
  });
};

productCardAdditionalImagesArrowsInit = () => {
  const cards = document.querySelectorAll('product-card');

  if (!cards.length) return;

  cards.forEach((card) => {
    if (card.dataset.additionalImagesScrolling === 'scrollbar') return;
    if (card.dataset.jscAdditionalImagesArrowsInit === 'true') return;

    const slider = card.querySelector('.product-card--image');
    const viewport = card.querySelector('.product-card--image-inner');
    const image = card.querySelector('.product-primary-image');
    const nav = card.querySelector('.product-card--nav-container');
    const navPrev = card.querySelector('.product-card--nav-prev');
    const navNext = card.querySelector('.product-card--nav-next');

    if (!slider || !viewport || !image || !nav || !navPrev || !navNext) return;

    let slideWidth = 0;
    let reachedEnd = false;
    const slidesToScroll = 1;

    const onNavDisabled = function () {
      navPrev.disabled = slider.scrollLeft === 0;
      navNext.disabled = reachedEnd;
    };

    const onScroll = function () {
      reachedEnd = (slider.scrollWidth - slider.offsetWidth) - Math.floor(slider.scrollLeft) <= 1;
      onNavDisabled();
    };

    const debouncedOnScroll = debounce(onScroll, 100);

    const resizeObserver = new ResizeObserver(() => {
      slideWidth = image.offsetWidth;
      reachedEnd = viewport.scrollWidth - viewport.offsetWidth === viewport.scrollLeft;
      onNavDisabled();
    });

    resizeObserver.observe(image);

    nav.addEventListener('click', function (e) {
      if (!e.target.matches('.product-card--nav')) return;

      let scrollPos = slider.scrollLeft;
      if (e.target.name === 'next') {
        scrollPos = slider.scrollLeft + slidesToScroll * slideWidth;
      } else if (e.target.name === 'prev') {
        scrollPos = slider.scrollLeft - slidesToScroll * slideWidth;
      }

      slider.scrollTo({
        left: scrollPos,
        behavior: 'smooth'
      });
    });

    slider.addEventListener('scroll', debouncedOnScroll);
    slider.addEventListener('resize', debouncedOnScroll);
    card.addEventListener('mouseleave', function () {
      slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    });

    window.addEventListener('load', function () {
      card.querySelectorAll('.product-secondary-image').forEach((additionalImage) => {
        lazySizes.loader.unveil(additionalImage);
      });
    });

    card.dataset.jscAdditionalImagesArrowsInit = 'true';
    onScroll();
  });
};

var hoverProductCardImage = () => {
  document.querySelectorAll('.product-card').forEach((cardEl) => {
    const secondImageWrap = cardEl.querySelector('.jsc-second-prod-image');
    if (!secondImageWrap || cardEl.dataset.jscHoverImageInit === 'true') return;

    cardEl.dataset.jscHoverImageInit = 'true';
 
    cardEl.addEventListener('mouseenter', () => {
      secondImageWrap.classList.remove('d-none');
    });
 
    cardEl.addEventListener('mouseleave', () => {
      secondImageWrap.classList.add('d-none');
    });
  });
};

/**
 * Product card sibling swatches (#17227): hover previews that colour's image, click opens its quick view.
 * Delegated so re-rendered grids and wishlist card clones keep working.
 */
function initJscProductCardSwatchInteractions() {
  if (initJscProductCardSwatchInteractions._bound) {
    return;
  }
  initJscProductCardSwatchInteractions._bound = true;

  var SWATCH_SELECTOR = '.product-card-sibling-swatches .product-card-swatch';

  function cardOf(el) {
    return (
      el.closest('product-card') ||
      el.closest('.product-card') ||
      el.closest('.swym-storefront-layout-grid-item')
    );
  }

  function cardImage(card) {
    if (!card) {
      return null;
    }
    return card.querySelector('.product-primary-image') || card.querySelector('.product-card--image-primary img');
  }

  /** Hovering the card scrolls the gallery to the second image, which would hide the swapped one. */
  function showFirstSlide(card) {
    var slider = card ? card.querySelector('.product-card--image') : null;
    if (slider && slider.scrollLeft > 0) {
      slider.scrollTo({ left: 0, behavior: 'auto' });
    }
  }

  function previewColor(swatch) {
    var card = cardOf(swatch);
    var image = cardImage(card);
    var srcset = swatch.getAttribute('data-preview-srcset');
    if (!image || !srcset) {
      return;
    }
    image.setAttribute('srcset', srcset);
    showFirstSlide(card);
  }

  function siblingSwatchTooltip(swatch) {
    var wrap = swatch.closest('.jsc-product-card-sibling-swatches-wrap');
    return wrap ? wrap.querySelector('.jsc-product-card-swatch-tooltip--sibling') : null;
  }

  function showSiblingSwatchTooltip(swatch) {
    var tooltip = siblingSwatchTooltip(swatch);
    var label = swatch.getAttribute('data-swatch-tooltip');
    if (!tooltip || !label) {
      return;
    }
    tooltip.textContent = label;
    tooltip.classList.add('is-visible');
    tooltip.setAttribute('aria-hidden', 'false');
  }

  function hideSiblingSwatchTooltip(grid) {
    var wrap = grid ? grid.closest('.jsc-product-card-sibling-swatches-wrap') : null;
    if (!wrap) {
      return;
    }
    var tooltip = wrap.querySelector('.jsc-product-card-swatch-tooltip--sibling');
    if (!tooltip) {
      return;
    }
    tooltip.classList.remove('is-visible');
    tooltip.setAttribute('aria-hidden', 'true');
  }

  function resetPreview(card) {
    var image = cardImage(card);
    // lazySizes keeps the card's own srcset in data-srcset, so it survives the hover swaps.
    if (image && image.dataset.srcset) {
      image.setAttribute('srcset', image.dataset.srcset);
    }
  }

  function quickViewOpener() {
    if (!window.customElements || !customElements.get('quick-view')) {
      return null;
    }
    if (!document.getElementById('Product-Drawer') || !document.querySelector('.click-capture--product')) {
      return null;
    }
    var opener = document.getElementById('jsc-swatch-quick-view');
    if (!opener) {
      opener = document.createElement('quick-view');
      opener.id = 'jsc-swatch-quick-view';
      opener.style.display = 'none';
      document.body.appendChild(opener);
    }
    return opener;
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) {
      return;
    }
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) {
      return;
    }
    previewColor(swatch);
    showSiblingSwatchTooltip(swatch);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target || !e.target.closest) {
      return;
    }
    var grid = e.target.closest('.product-card-sibling-swatches');
    if (!grid || (e.relatedTarget && grid.contains(e.relatedTarget))) {
      return;
    }
    resetPreview(cardOf(grid));
    hideSiblingSwatchTooltip(grid);
  });

  document.addEventListener('focusin', function (e) {
    if (!e.target || !e.target.closest) {
      return;
    }
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) {
      return;
    }
    showSiblingSwatchTooltip(swatch);
  });

  document.addEventListener('focusout', function (e) {
    if (!e.target || !e.target.closest) {
      return;
    }
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) {
      return;
    }
    var grid = swatch.closest('.product-card-sibling-swatches');
    if (!grid || (e.relatedTarget && grid.contains(e.relatedTarget))) {
      return;
    }
    hideSiblingSwatchTooltip(grid);
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) {
      return;
    }
    var link = e.target.closest('a.product-card-swatch[data-sibling-handle]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }
    var handle = link.getAttribute('data-sibling-handle');
    if (!handle) {
      return;
    }
    var drawer = document.getElementById('Product-Drawer');
    if (drawer && drawer.classList.contains('active') && typeof window.jscReloadQuickViewProduct === 'function') {
      e.preventDefault();
      window.jscReloadQuickViewProduct(handle);
      return;
    }
    var opener = quickViewOpener();
    if (!opener) {
      // No drawer on this template: keep the link navigating to the sibling product.
      return;
    }
    e.preventDefault();
    opener.dataset.productHandle = handle;
    opener.click();
  });
}

initJscProductGalleryChrome = () => {
  var ROW_TOP_TOLERANCE = 8;

  function getVisibleSlides(slider) {
    return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(function (el) {
      return el.clientWidth > 0;
    });
  }

  function buildRowsHorizontal(slides) {
    return slides.map(function (s) {
      return [s];
    });
  }

  function buildRowsGrid(slides) {
    var tops = [];
    slides.forEach(function (slide) {
      var t = slide.offsetTop;
      var found = false;
      for (var i = 0; i < tops.length; i++) {
        if (Math.abs(tops[i] - t) < ROW_TOP_TOLERANCE) {
          found = true;
          break;
        }
      }
      if (!found) {
        tops.push(t);
      }
    });
    tops.sort(function (a, b) {
      return a - b;
    });
    return tops.map(function (top) {
      return slides.filter(function (s) {
        return Math.abs(s.offsetTop - top) < ROW_TOP_TOLERANCE;
      });
    });
  }

  function findRowIndexForSlide(slide, rows) {
    for (var r = 0; r < rows.length; r++) {
      if (rows[r].indexOf(slide) !== -1) {
        return r;
      }
    }
    return 0;
  }

  function activeSlideIndexVertical(slides, viewEl) {
    var viewTop = 0;
    var viewBottom = window.innerHeight;
    if (viewEl) {
      var vr = viewEl.getBoundingClientRect();
      viewTop = vr.top;
      viewBottom = vr.bottom;
    }
    var bestIdx = 0;
    var bestVis = 0;
    slides.forEach(function (slide, i) {
      var r = slide.getBoundingClientRect();
      var vis = Math.min(r.bottom, viewBottom) - Math.max(r.top, viewTop);
      if (vis > bestVis) {
        bestVis = vis;
        bestIdx = i;
      }
    });
    return bestIdx;
  }

  /** Prefer intrinsic media box height so grid stretch / overlay does not feedback into ResizeObserver loops. */
  function getSlideContentHeight(slide) {
    if (!slide) return 0;
    var media = slide.querySelector('.product-single__media');
    if (media && media.offsetHeight > 0) {
      return media.offsetHeight;
    }
    return slide.offsetHeight;
  }

  function bindChrome(root) {
    const container = root.closest('.product-image-container');
    const slider = container ? container.querySelector('product-slider') : null;
    const galleryViewport = slider ? slider.closest('[data-jsc-pdp-gallery-viewport]') : null;
    const dotsContainer = root.querySelector('[data-jsc-gallery-dots]');
    const stickyEl = root.querySelector('.jsc-product-gallery-chrome__sticky');

    if (!slider || !dotsContainer) return;

    const mqHorizontalCarousel = window.matchMedia('(min-width: 99999px)');
    const mqPhone = window.matchMedia('(max-width: 767px)');
    let onScroll = null;
    let scrollEl = null;
    let raf = 0;
    let rowModel = [];
    var lastStickyHeightPx = -1;

    /* Match action and pagination dots height to the first row of slides. */
    function updateStickyFirstRowHeight() {
      if (!stickyEl) return;
      const slides = getVisibleSlides(slider);
      if (!slides.length) {
        stickyEl.style.removeProperty('height');
        lastStickyHeightPx = -1;
        return;
      }
      if (galleryViewport && mqPhone.matches) {
        var pad = 32;
        var vh = Math.max(0, galleryViewport.clientHeight - pad);
        if (vh > 0) {
          if (lastStickyHeightPx >= 0 && Math.abs(vh - lastStickyHeightPx) < 1) {
            return;
          }
          lastStickyHeightPx = vh;
          stickyEl.style.height = vh + 'px';
        }
        return;
      }
      var h = 0;
      if (mqHorizontalCarousel.matches) {
        h = getSlideContentHeight(slides[0]);
      } else if (slides.length === 1) {
        h = getSlideContentHeight(slides[0]);
      } else {
        const rows = buildRowsGrid(slides);
        if (!rows.length || !rows[0].length) {
          stickyEl.style.removeProperty('height');
          lastStickyHeightPx = -1;
          return;
        }
        rows[0].forEach(function (el) {
          h = Math.max(h, getSlideContentHeight(el));
        });
      }
      if (h > 0) {
        if (lastStickyHeightPx >= 0 && Math.abs(h - lastStickyHeightPx) < 1) {
          return;
        }
        lastStickyHeightPx = h;
        stickyEl.style.height = h + 'px';
      }
    }

    function teardownListeners() {
      if (onScroll) {
        window.removeEventListener('scroll', onScroll);
        slider.removeEventListener('scroll', onScroll);
        if (scrollEl && scrollEl !== window) {
          scrollEl.removeEventListener('scroll', onScroll);
        }
        scrollEl = null;
        onScroll = null;
      }
    }

    function setActiveRow(rowIdx) {
      const dots = dotsContainer.querySelectorAll('.jsc-product-gallery-dot');
      dots.forEach(function (d, j) {
        const on = j === rowIdx;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function updateActive() {
      const slides = getVisibleSlides(slider);
      if (slides.length < 2 || rowModel.length === 0) return;

      let rowIdx = 0;
      if (mqHorizontalCarousel.matches) {
        const step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 0;
        let slideIdx = 0;
        if (step > 0) {
          slideIdx = Math.min(slides.length - 1, Math.round(slider.scrollLeft / step));
        }
        rowIdx = findRowIndexForSlide(slides[slideIdx], rowModel);
      } else {
        var visEl = galleryViewport || null;
        const slideIdx = activeSlideIndexVertical(slides, visEl);
        rowIdx = findRowIndexForSlide(slides[slideIdx], rowModel);
      }
      setActiveRow(rowIdx);
    }

    function scheduleUpdate() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        raf = 0;
        updateActive();
      });
    }

    function buildDots() {
      teardownListeners();
      dotsContainer.innerHTML = '';
      const slides = getVisibleSlides(slider);
      if (slides.length < 2) {
        updateStickyFirstRowHeight();
        return;
      }

      rowModel = mqHorizontalCarousel.matches ? buildRowsHorizontal(slides) : buildRowsGrid(slides);
      const rowCount = rowModel.length;

      rowModel.forEach(function (row, i) {
        const targetSlide = row[0];
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jsc-product-gallery-dot';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute(
          'aria-label',
          'Gallery row ' + (i + 1) + ' of ' + rowCount + ' (' + row.length + ' image' + (row.length === 1 ? '' : 's') + ')'
        );
        btn.addEventListener('click', function () {
          if (mqHorizontalCarousel.matches) {
            slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
          } else {
            targetSlide.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        dotsContainer.appendChild(btn);
      });

      if (mqHorizontalCarousel.matches) {
        onScroll = scheduleUpdate;
        scrollEl = slider;
        slider.addEventListener('scroll', onScroll, { passive: true });
      } else {
        onScroll = scheduleUpdate;
        scrollEl = galleryViewport || window;
        scrollEl.addEventListener('scroll', onScroll, { passive: true });
      }
      scheduleUpdate();
      updateStickyFirstRowHeight();
    }

    const mo = new MutationObserver(function () {
      buildDots();
    });
    mo.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });

    let ro = null;
    let roFrame = 0;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(function () {
        if (roFrame) return;
        roFrame = requestAnimationFrame(function () {
          roFrame = 0;
          buildDots();
        });
      });
      ro.observe(slider);
      if (galleryViewport) {
        ro.observe(galleryViewport);
      }
    }

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        updateStickyFirstRowHeight();
      });
    }

    window.addEventListener(
      'resize',
      function () {
        buildDots();
      },
      { passive: true }
    );

    mqHorizontalCarousel.addEventListener('change', function () {
      buildDots();
    });

    buildDots();
  }

  function run() {
    document.querySelectorAll('[data-jsc-product-gallery-chrome]').forEach(bindChrome);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
};

initJscPdpMobileScroll = function () {
  var mq = window.matchMedia('(max-width: 767px)');
  document.querySelectorAll('.jsc-main-product[data-jsc-pdp-mobile-scroll]').forEach(function (root) {
    var slider = root.querySelector('product-slider.product-images');
    if (!slider || slider.getAttribute('data-jsc-pdp-wheel') === 'true') return;
    slider.setAttribute('data-jsc-pdp-wheel', 'true');
    slider.addEventListener(
      'wheel',
      function (e) {
        if (!mq.matches) return;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (maxScroll <= 0) return;
        if (e.ctrlKey) return;
        if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
        var atStart = slider.scrollLeft <= 1;
        var atEnd = slider.scrollLeft >= maxScroll - 1;
        if (atStart && e.deltaY < 0) return;
        if (atEnd && e.deltaY > 0) return;
        e.preventDefault();
        var prefersReduced =
          typeof window.matchMedia === 'function' &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var delta = e.deltaY;
        if (prefersReduced) {
          slider.scrollLeft += delta;
        } else {
          slider.scrollTo({ left: slider.scrollLeft + delta, behavior: 'auto' });
        }
      },
      { passive: false }
    );
  });
};

initJscPdpSizeRequiredAtc = function () {
  var MSG = 'Please Select your Size';

  function sectionIdFromProductForm(form) {
    var id = form && form.getAttribute ? form.getAttribute('id') || '' : '';
    if (!id || id.indexOf('product-form-') !== 0) return null;
    return id.slice('product-form-'.length);
  }

  function mainVariantSelects(sectionId) {
    return document.getElementById('variant-selects-' + sectionId);
  }

  function isVariantIdMissingForAddToCart(form) {
    var inp = form.querySelector('input[name="id"]');
    if (!inp) return true;
    if (inp.disabled) return true;
    var v = (inp.value || '').trim();
    return v === '';
  }

  function selectAwaitingChoice(sel) {
    if (!sel || sel.nodeName !== 'SELECT') return false;
    if (sel.value === '') return true;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return true;
    if (opt.getAttribute('data-placeholder') === 'true') return true;
    if (opt.classList && opt.classList.contains('jsc-size-placeholder--hidden')) return true;
    return false;
  }

  function hasEmptyOptionSelect(sectionId) {
    var vs = mainVariantSelects(sectionId);
    if (!vs) return false;
    var sels = vs.querySelectorAll('fieldset select');
    for (var i = 0; i < sels.length; i++) {
      if (selectAwaitingChoice(sels[i])) return true;
    }
    return false;
  }

  function firstEmptySizeFieldContext(sectionId) {
    var vs = mainVariantSelects(sectionId);
    if (!vs) return null;
    var sels = vs.querySelectorAll('fieldset select');
    for (var i = 0; i < sels.length; i++) {
      if (!selectAwaitingChoice(sels[i])) continue;
      var fs = sels[i].closest('fieldset');
      var handle = (fs && fs.getAttribute('data-handle')) || '';
      return { select: sels[i], fieldset: fs, handle: handle };
    }
    return null;
  }

  function jscPdpSizeBlocksAtc(form, sectionId) {
    if (isVariantIdMissingForAddToCart(form)) return true;
    if (hasEmptyOptionSelect(sectionId)) return true;
    return false;
  }

  function ensureMsgEl(container) {
    if (!container) return null;
    var el = container.querySelector('.jsc-pdp-size-required-msg');
    if (!el) {
      el = document.createElement('p');
      el.className = 'jsc-pdp-size-required-msg';
      el.textContent = MSG;
      el.setAttribute('hidden', '');
      container.appendChild(el);
    }
    return el;
  }

  /** Native variant-selects: place the message after `.select` inside `.product-form__input-wrapper`. */
  function ensureMsgAfterSelectBox(wrapper, selectEl) {
    if (!wrapper) return null;
    var msg = wrapper.querySelector('.jsc-pdp-size-required-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'jsc-pdp-size-required-msg';
      msg.textContent = MSG;
      msg.setAttribute('hidden', '');
    }
    var selectBox =
      (selectEl && selectEl.closest && selectEl.closest('.select')) || wrapper.querySelector('.select');
    if (selectBox) {
      if (msg.previousElementSibling !== selectBox) {
        selectBox.insertAdjacentElement('afterend', msg);
      }
    } else if (!wrapper.contains(msg)) {
      wrapper.appendChild(msg);
    }
    return msg;
  }

  function setPdpSizeRequiredFormBanner(sectionId, text) {
    var show = !!(text && String(text).trim());
    document.querySelectorAll('product-form[data-section="' + sectionId + '"]').forEach(function (pf) {
      if (pf.getAttribute('data-hide-errors') === 'true') return;
      var wrap = pf.querySelector('.product-form__error-message-wrapper');
      var span = wrap && wrap.querySelector('.product-form__error-message');
      if (!wrap || !span) return;
      if (show) {
        span.textContent = text;
        wrap.removeAttribute('hidden');
      } else {
        span.textContent = '';
        wrap.setAttribute('hidden', '');
      }
    });
  }

  function clearSizeRequiredUi(sectionId) {
    setPdpSizeRequiredFormBanner(sectionId, '');
    var vs = mainVariantSelects(sectionId);
    if (vs) {
      vs.querySelectorAll('fieldset.jsc-pdp-size-field--error').forEach(function (fs) {
        fs.classList.remove('jsc-pdp-size-field--error');
      });
      vs.querySelectorAll('.jsc-pdp-size-required-msg').forEach(function (p) {
        p.setAttribute('hidden', '');
      });
    }
    var vp = document.getElementById('jsc-variant-picker-' + sectionId);
    if (vp) {
      vp.querySelectorAll('.jsc-variant-picker__field.jsc-pdp-size-field--error').forEach(function (row) {
        row.classList.remove('jsc-pdp-size-field--error');
      });
      vp.querySelectorAll('.jsc-pdp-size-required-msg').forEach(function (p) {
        p.setAttribute('hidden', '');
      });
    }
  }

  function showSizeRequiredUi(sectionId, scrollHintSticky) {
    var vp = document.getElementById('jsc-variant-picker-' + sectionId);
    var visibleRow = null;
    var visibleSelect = null;
    var scrollAnchor = null;
    if (vp) {
      visibleSelect = Array.prototype.find.call(vp.querySelectorAll('[data-jsc-secondary-select]'), function (sel) {
        return selectAwaitingChoice(sel);
      });
      if (visibleSelect) {
        visibleRow = visibleSelect.closest('.jsc-variant-picker__field');
      }
    }

    if (visibleRow && visibleSelect) {
      visibleRow.classList.add('jsc-pdp-size-field--error');
      var msg = ensureMsgEl(visibleRow);
      if (msg) msg.removeAttribute('hidden');
      scrollAnchor = visibleRow;
    } else {
      var ctx = firstEmptySizeFieldContext(sectionId);
      if (ctx && ctx.fieldset) {
        ctx.fieldset.classList.add('jsc-pdp-size-field--error');
        var inJscField = ctx.select && ctx.select.closest && ctx.select.closest('.jsc-variant-picker__field');
        var inputWrap = ctx.select && ctx.select.closest && ctx.select.closest('.product-form__input-wrapper');
        var msgCtx = null;
        if (!inJscField && inputWrap) {
          msgCtx = ensureMsgAfterSelectBox(inputWrap, ctx.select);
          scrollAnchor = inputWrap;
        } else {
          msgCtx = inJscField ? ensureMsgEl(inJscField) : ensureMsgEl(ctx.fieldset);
          scrollAnchor = inJscField || ctx.fieldset;
        }
        if (msgCtx) msgCtx.removeAttribute('hidden');
      } else if (vp) {
        var fallbackRow = vp.querySelector('[data-jsc-secondary-row]');
        if (fallbackRow) {
          fallbackRow.classList.add('jsc-pdp-size-field--error');
          var msgFb = ensureMsgEl(fallbackRow);
          if (msgFb) msgFb.removeAttribute('hidden');
          scrollAnchor = fallbackRow;
        }
      }
    }

    if (scrollHintSticky) {
      var scrollEl =
        (vp && vp.querySelector('.jsc-variant-picker__secondary')) ||
        scrollAnchor ||
        mainVariantSelects(sectionId);
      if (scrollEl && typeof scrollEl.scrollIntoView === 'function') {
        scrollEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  function isStickyAtcButton(btn) {
    if (!btn) return false;
    if (btn.id === 'AddToCartSticky') return true;
    if (btn.classList && btn.classList.contains('jsc-product-add-to-cart-sticky__atc')) return true;
    return false;
  }

  function isJscPdpAtcButton(btn) {
    if (!btn || btn.nodeName !== 'BUTTON') return false;
    if (btn.getAttribute('name') !== 'add') return false;
    if (!btn.classList || !btn.classList.contains('single-add-to-cart-button')) return false;
    if (btn.closest && btn.closest('.jsc-main-product')) return true;
    var fid = btn.getAttribute('form');
    if (fid) {
      var f = document.getElementById(fid);
      if (
        f &&
        f.getAttribute('data-type') === 'add-to-cart-form' &&
        f.closest &&
        f.closest('.jsc-main-product')
      ) {
        return true;
      }
    }
    return false;
  }

  function resolvePdpAddToCartForm(btn) {
    var formEl = btn.form;
    if (!formEl && btn.getAttribute('form')) {
      formEl = document.getElementById(btn.getAttribute('form'));
    }
    if (!formEl || formEl.getAttribute('data-type') !== 'add-to-cart-form') return null;
    if (!formEl.closest || !formEl.closest('.jsc-main-product')) return null;
    return formEl;
  }

  /**
   * Validates size / variant for the PDP main product form, then submits with the given button as submitter.
   * @param {Event} [event] — optional; if passed, default is prevented (use for click path).
   * @param {HTMLButtonElement} [submitButton] — optional; inferred from event.target when omitted.
   * @returns {boolean} true if submit was requested, false if validation blocked or ignored.
   */
  window.jscCheckout = function (event, submitButton) {
    if (window.theme && theme.settings && theme.settings.hide_atc_button) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return false;
    }
    // Resolve the clicked ATC button and the form it submits.
    var btn = submitButton;
    if (!btn && event && event.target && event.target.closest) {
      btn = event.target.closest('button.single-add-to-cart-button[name="add"]');
    }
    if (!btn || !isJscPdpAtcButton(btn)) return false;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading')) {
      return false;
    }

    // Block the native submit unconditionally; submission below is ours to drive.
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    var formEl = resolvePdpAddToCartForm(btn);
    if (!formEl) return false;
    var sectionId = sectionIdFromProductForm(formEl);
    if (!sectionId) return false;

    // Step 1: validate that a size is selected.
    if (jscPdpSizeBlocksAtc(formEl, sectionId)) {
      // Step 3 (Fail): surface the dropdown error message.
      showSizeRequiredUi(sectionId, isStickyAtcButton(btn));
      return false;
    }

    // Step 2 (Pass): submit the form to add to cart.
    if (typeof formEl.requestSubmit === 'function') {
      formEl.requestSubmit(btn);
    } else {
      var subEv = new Event('submit', { bubbles: true, cancelable: true });
      Object.defineProperty(subEv, 'submitter', { value: btn, enumerable: true });
      formEl.dispatchEvent(subEv);
    }
    return true;
  };

  if (window.jscPdpSizeRequiredAtcBound) {
    return;
  }
  window.jscPdpSizeRequiredAtcBound = true;

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (!form.closest || !form.closest('.jsc-main-product')) return;
      var sectionId = sectionIdFromProductForm(form);
      if (!sectionId) return;
      if (!jscPdpSizeBlocksAtc(form, sectionId)) return;

      e.preventDefault();
      e.stopPropagation();
      var sticky = false;
      var sub = typeof e.submitter !== 'undefined' ? e.submitter : null;
      if (sub && isStickyAtcButton(sub)) sticky = true;
      showSizeRequiredUi(sectionId, sticky);
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || t.nodeName !== 'SELECT') return;

      var inMainPdp = t.closest && t.closest('.jsc-main-product');
      var vsEl = t.closest && t.closest('variant-selects');
      var isStickyVariantSelect =
        vsEl && vsEl.id && String(vsEl.id).indexOf('variant-selects-') === 0 && String(vsEl.id).indexOf('--sticky') !== -1;
      var inJscPicker = t.closest && t.closest('[id^="jsc-variant-picker-"]');
      if (!inMainPdp && !isStickyVariantSelect && !inJscPicker) return;

      var sid = null;
      if (inMainPdp) {
        var form = inMainPdp.querySelector('form[data-type="add-to-cart-form"]');
        sid = sectionIdFromProductForm(form);
      } else if (vsEl && vsEl.dataset && vsEl.dataset.section) {
        sid = String(vsEl.dataset.section);
      } else if (inJscPicker) {
        var pk = t.closest('[id^="jsc-variant-picker-"]');
        if (pk && pk.id && pk.id.indexOf('jsc-variant-picker-') === 0) {
          sid = pk.id.slice('jsc-variant-picker-'.length);
        }
      }
      if (!sid) return;
      // The hidden variant input updates asynchronously (rAF + fetch), so
      // isVariantIdMissingForAddToCart lags behind. Gate only on whether the
      // visible selects still have an unresolved placeholder.
      if (selectAwaitingChoice(t)) return;
      if (inJscPicker) {
        // Visible picker path: check all secondary selects in this picker.
        var anyEmpty = false;
        inJscPicker.querySelectorAll('[data-jsc-secondary-select]').forEach(function (s) {
          if (selectAwaitingChoice(s)) anyEmpty = true;
        });
        if (anyEmpty) return;
      } else if (hasEmptyOptionSelect(sid)) {
        // Legacy / sticky path: check the fieldset selects.
        return;
      }
      clearSizeRequiredUi(sid);
    },
    false
  );
};

/**
 * PDP mobile: put all colour controls before the title/price/review block.
 * Real DOM order keeps both the visual and keyboard order consistent.
 */
initJscPdpMobileColorHeadOrder = function () {
  var mq = window.matchMedia('(max-width: 767px)');

  function relocateAll() {
    document.querySelectorAll('.jsc-main-product sticky-scroller.product-information').forEach(function (productInfo) {
      var sheetContent = productInfo.querySelector('.jsc-pdp-mobile-sheet__content');
      if (!sheetContent) return;
      var title = sheetContent.querySelector('.product-title-container');
      var siblings = productInfo.querySelector('.jsc-product-siblings');
      var root = productInfo.querySelector('.jsc-variant-picker[data-section]');
      var colorHead = productInfo.querySelector('.jsc-variant-picker__color-head');
      var inner = root ? root.querySelector('.jsc-variant-picker__inner') : null;
      if (!title) return;

      if (mq.matches) {
        if (siblings && siblings.nextElementSibling !== title) {
          sheetContent.insertBefore(siblings, title);
        }
        if (colorHead && colorHead.nextElementSibling !== title) {
          sheetContent.insertBefore(colorHead, title);
        }
      } else {
        if (colorHead && inner && colorHead.parentNode === sheetContent) {
          inner.insertBefore(colorHead, inner.firstChild);
        }
        if (siblings && siblings.parentNode === sheetContent && title.nextElementSibling !== siblings) {
          title.insertAdjacentElement('afterend', siblings);
        }
      }
    });
  }

  window.jscRelocatePdpColorHeadAll = relocateAll;

  relocateAll();

  var resizeTimer = null;
  window.addEventListener(
    'resize',
    function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resizeTimer = null;
        relocateAll();
      }, 150);
    },
    { passive: true }
  );

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', relocateAll);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(relocateAll);
  }
};

/**
 * Multi-tier cart GWP (._cartGwp), cart/product/collection GWP (.jsc-cart-gift*),
 * and tier cleanup (.jsc-remove-gwp). Refreshes cart sections like jungsaemmool masterPromo order:
 * tier → cart gift → remove lines.
 */
(function () {
  var cartGiftTimer = null;
  var cartGiftBusy = false;
  var cartGiftQuietUntil = 0;
  var cartGiftDebounceMs = 650;

  function showLoader(show) {
    var el = document.querySelector('.jsc-loader-overlay');
    if (!el) return;
    el.style.display = show ? 'block' : 'none';
  }

  function getCartGiftSectionsCsv() {
    var list = ['cart-drawer', 'cart-bubble'];
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var cartUrl = window.theme && theme.routes && theme.routes.cart_url ? theme.routes.cart_url : '/cart';
    var cartPath = cartUrl.replace(/\/$/, '');
    if (path === cartPath || path.endsWith('/cart')) {
      list.push('main-cart');
    }
    return list.join(',');
  }

  function getJscBundledSectionsUrl() {
    var cartUrl = window.theme && theme.routes && theme.routes.cart_url ? theme.routes.cart_url : '/cart';
    try {
      var url = new URL(cartUrl, window.location.origin);
      return url.pathname + (window.location.search || '');
    } catch (e) {
      return (window.location.pathname || '/cart') + (window.location.search || '');
    }
  }

  function parseSectionInner(html, selector) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function applySectionsFromResponse(parsed) {
    if (!parsed || !parsed.sections) return;

    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && parsed.sections['cart-drawer']) {
      var inner = parseSectionInner(parsed.sections['cart-drawer'], '.cart-drawer');
      if (inner) {
        var target = drawer.querySelector('.cart-drawer') || drawer;
        target.innerHTML = inner;
      }
      if (typeof drawer.notesToggle === 'function') drawer.notesToggle();
      if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
      if (typeof drawer.initializeWishlistButtons === 'function') drawer.initializeWishlistButtons();
    }

    var bubbleHost = document.getElementById('cart-drawer-toggle');
    if (bubbleHost && parsed.sections['cart-bubble']) {
      var bubbleInner = parseSectionInner(parsed.sections['cart-bubble'], '.thb-item-count');
      if (bubbleInner) {
        var bEl = bubbleHost.querySelector('.thb-item-count') || bubbleHost;
        bEl.innerHTML = bubbleInner;
      }
    }

    var cartRoot = document.getElementById('Cart');
    if (cartRoot && parsed.sections['main-cart']) {
      var cartLayout = cartRoot.getAttribute('data-cart-layout');
      if (cartLayout === 'v2' && typeof cartRoot.refresh === 'function') {
        // For v2, let ThemeCart pull the canonical section markup instead of injecting
        // possibly stale/fallback HTML from promo responses.
        cartRoot.refresh();
      } else {
        var innerForm = parseSectionInner(parsed.sections['main-cart'], '.thb-cart-form');
        if (innerForm) {
          var formTarget = cartRoot.querySelector('.thb-cart-form') || cartRoot;
          formTarget.innerHTML = innerForm;
        }
      }
    }
  }

  function fetchCartJson() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function findCartItemByKey(cart, key) {
    if (key == null || key === '') return null;
    var s = String(key);
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].key) === s) {
        return { item: cart.items[i], line: i + 1 };
      }
    }
    return null;
  }

  function mergeProperties(existing, additions) {
    var o = {};
    if (existing && typeof existing === 'object') {
      Object.keys(existing).forEach(function (k) {
        if (existing[k] != null && existing[k] !== '') o[k] = existing[k];
      });
    }
    if (additions && typeof additions === 'object') {
      Object.keys(additions).forEach(function (k) {
        o[k] = additions[k];
      });
    }
    return o;
  }

  function cartGiftProps(promoNo) {
    return {
      _Cart_Gift: String(promoNo),
      _Cart_GWP: 'Free Gift'
    };
  }

  function postCartChange(changeUrl, body) {
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.text().then(function (text) {
          return { ok: res.ok, text: text };
        });
      })
      .then(function (o) {
        var parsed;
        try {
          parsed = JSON.parse(o.text);
        } catch (e) {
          console.warn('[jsc cart change] invalid JSON', o.text);
          return null;
        }
        if (parsed && parsed.errors) {
          console.warn('[jsc cart change]', parsed.errors);
        }
        return parsed;
      });
  }

  function cartChangeLine(lineKey, quantity, extraProps) {
    var changeUrl =
      window.theme && window.theme.routes && window.theme.routes.cart_change_url
        ? window.theme.routes.cart_change_url
        : '/cart/change';

    if (lineKey == null || lineKey === '') {
      return Promise.resolve(null);
    }

    return fetchCartJson().then(function (cart) {
      var found = findCartItemByKey(cart, lineKey);
      if (quantity > 0) {
        if (!found) return Promise.resolve(null);
        var item = found.item;
        var body = {
          id: String(lineKey),
          quantity: quantity,
          sections: getCartGiftSectionsCsv(),
          sections_url: getJscBundledSectionsUrl()
        };
        if (extraProps) {
          body.properties = mergeProperties(item.properties, extraProps);
        }
        return postCartChange(changeUrl, body);
      }
      return postCartChange(changeUrl, {
        id: String(lineKey),
        quantity: 0,
        sections: getCartGiftSectionsCsv(),
        sections_url: getJscBundledSectionsUrl()
      });
    });
  }

  /** Replaces the full line item properties (needed when stripping PWP fields from a line with remaining props). */
  function cartChangeLineReplaceProperties(lineKey, quantity, newProps) {
    var changeUrl =
      window.theme && window.theme.routes && window.theme.routes.cart_change_url
        ? window.theme.routes.cart_change_url
        : '/cart/change';
    if (lineKey == null || lineKey === '' || quantity <= 0) {
      return Promise.resolve(null);
    }
    return fetchCartJson().then(function (cart) {
      var found = findCartItemByKey(cart, lineKey);
      if (!found) {
        return Promise.resolve(null);
      }
      var body = {
        id: String(lineKey),
        quantity: quantity,
        properties: newProps && typeof newProps === 'object' ? newProps : {},
        sections: getCartGiftSectionsCsv(),
        sections_url: getJscBundledSectionsUrl()
      };
      return postCartChange(changeUrl, body);
    });
  }

  function cartAddGiftVariant(variantId, qty, promoNo) {
    var addUrl =
      window.theme && theme.routes && theme.routes.cart_add_url ? theme.routes.cart_add_url : '/cart/add';

    var body = {
      items: [
        {
          id: variantId,
          quantity: qty,
          properties: cartGiftProps(promoNo)
        }
      ],
      sections: getCartGiftSectionsCsv(),
      sections_url: getJscBundledSectionsUrl()
    };

    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        return JSON.parse(text);
      });
  }

  function tierGwpProperties(tierNo, colAttr) {
    var tierKey = 'GWP Tier ' + tierNo;
    var o = {};
    o[tierKey] = 'true';
    o['_Cart_GWP'] = 'Free Gift';
    if (colAttr) {
      o['_GWP_col'] = colAttr;
    }
    return o;
  }

  function cartAddWithProperties(variantId, quantity, properties) {
    var addUrl =
      window.theme && theme.routes && theme.routes.cart_add_url ? theme.routes.cart_add_url : '/cart/add';
    var body = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: properties
        }
      ],
      sections: getCartGiftSectionsCsv(),
      sections_url: getJscBundledSectionsUrl()
    };
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        return JSON.parse(text);
      });
  }

  function processOneTierGwp(el) {
    var vid = parseInt(el.getAttribute('data-vid'), 10);
    var tierNo = el.getAttribute('data-tier');
    var col = el.getAttribute('data-col') || '';

    return fetchCartJson().then(function (cart) {
      var tierKey = 'GWP Tier ' + tierNo;
      var existingKey = null;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.variant_id === vid && it.properties && it.properties[tierKey]) {
          existingKey = it.key;
          break;
        }
      }
      var props = tierGwpProperties(tierNo, col);
      if (existingKey) {
        return cartChangeLine(existingKey, 1, props);
      }
      return cartAddWithProperties(vid, 1, props);
    });
  }

  function runCartGiftLines(startChain) {
    var chain = startChain || Promise.resolve(null);

    document.querySelectorAll('.jsc-cart-gift-remove').forEach(function (el) {
      var key = el.value;
      chain = chain.then(function () {
        return cartChangeLine(key, 0, null);
      });
    });

    document.querySelectorAll('.jsc-cart-gift-upt').forEach(function (el) {
      var key = el.value;
      var qty = parseInt(el.getAttribute('data-qty'), 10);
      var promoNo = el.getAttribute('data-promo');
      chain = chain.then(function () {
        return cartChangeLine(key, qty, cartGiftProps(promoNo));
      });
    });

    document.querySelectorAll('.jsc-cart-gift').forEach(function (el) {
      var vid = parseInt(el.value, 10);
      var promoNo = el.getAttribute('data-promo');
      var giftQty = parseInt(el.getAttribute('data-gift-qty'), 10) || 1;

      chain = chain.then(function () {
        return fetchCartJson().then(function (cart) {
          var existingKey = null;
          for (var j = 0; j < cart.items.length; j++) {
            var it = cart.items[j];
            var pg = it.properties && it.properties._Cart_Gift;
            if (it.variant_id === vid && String(pg) === String(promoNo)) {
              existingKey = it.key;
              break;
            }
          }
          if (existingKey) {
            return cartChangeLine(existingKey, giftQty, cartGiftProps(promoNo));
          }
          return cartAddGiftVariant(vid, giftQty, promoNo);
        });
      });
    });

    return chain;
  }

  function cartAddBundlePair(vid1, vid2, prop1, prop2) {
    var addUrl =
      window.theme && theme.routes && theme.routes.cart_add_url ? theme.routes.cart_add_url : '/cart/add';
    var body = {
      items: [
        { id: vid1, quantity: 1, properties: prop1 },
        { id: vid2, quantity: 1, properties: prop2 }
      ],
      sections: getCartGiftSectionsCsv(),
      sections_url: getJscBundledSectionsUrl()
    };
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        return JSON.parse(text);
      });
  }

  function replaceBundleLine(lineKey, variantId, qty) {
    return cartChangeLine(lineKey, 0, null).then(function (parsed) {
      if (parsed && parsed.sections) applySectionsFromResponse(parsed);
      return cartAddWithProperties(variantId, qty, {});
    });
  }

  function bundleCartAjax(bindId) {
    return fetchCartJson().then(function (cart) {
      var chain = Promise.resolve(null);
      for (var i = 0; i < cart.items.length; i++) {
        (function (item) {
          if (!item.properties || String(item.properties['_BindID']) !== String(bindId)) return;
          var key = item.key;
          var qty = item.quantity;
          var vid = parseInt(item.variant_id, 10);
          var props = {};
          Object.keys(item.properties || {}).forEach(function (k) {
            if (item.properties[k] != null && item.properties[k] !== '') props[k] = item.properties[k];
          });
          delete props['_Quantity-Promo'];
          delete props['_Off-Value'];
          delete props['_Bundle'];
          delete props['_BindID'];
          delete props['_Promo-no'];
          var hasKeys = Object.keys(props).length > 0;
          chain = chain.then(function () {
            if (!hasKeys) {
              return replaceBundleLine(key, vid, qty);
            }
            return cartChangeLine(key, qty, props);
          });
        })(cart.items[i]);
      }
      return chain;
    });
  }

  function updateBundleLimitsChain(chainIn) {
    var chain = chainIn;
    document.querySelectorAll('.jsc-update-bundle-fix').forEach(function (el) {
      chain = chain.then(function () {
        var key = el.value;
        var qty = parseInt(el.getAttribute('data-qty'), 10);
        var bindId = el.getAttribute('data-bindId');
        var promo = el.getAttribute('data-promo');
        var props = {
          _Bundle: true,
          _BindID: bindId,
          '_Promo-no': promo,
          '_Limit-Discount': true
        };
        return cartChangeLine(key, qty, props);
      });
    });
    return chain;
  }

  function removeDisabledBundleChain(chainIn) {
    var chain = chainIn;
    document.querySelectorAll('.jsc-remove-bundle').forEach(function (el) {
      chain = chain.then(function () {
        var bindId = el.value;
        var containerClass = el.getAttribute('data-container');
        if (containerClass) {
          var c = document.querySelector('.' + containerClass);
          if (c) c.style.display = 'none';
        }
        return new Promise(function (resolve) {
          setTimeout(function () {
            bundleCartAjax(bindId).then(resolve);
          }, 900);
        });
      });
    });
    return chain;
  }

  window.bundleAddToCart = function (evt, discount1, discount2, discountType, i) {
    if (window.theme && theme.settings && theme.settings.hide_atc_button) return;
    var root = evt && evt.closest ? evt.closest('.jsc-promoSection') : null;
    if (!root) return;
    var col1 = root.querySelector('.jsc-bundle-col-1');
    var col2 = root.querySelector('.jsc-bundle-col-2');
    if (!col1 || !col2) return;
    var vid1 = parseInt(col1.getAttribute('data-vid'), 10);
    var vid2 = parseInt(col2.getAttribute('data-vid'), 10);
    var bindId = vid1 + '-' + vid2;
    var promoNo = String(i);
    var prop1 = { _Bundle: true, _BindID: bindId, '_Promo-no': promoNo };
    var prop2 = { _Bundle: true, _BindID: bindId, '_Promo-no': promoNo };
    showLoader(true);
    cartAddBundlePair(vid1, vid2, prop1, prop2)
      .then(function (parsed) {
        if (parsed && parsed.sections) applySectionsFromResponse(parsed);
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (e) {
        console.warn('[jsc bundle]', e);
      })
      .finally(function () {
        showLoader(false);
      });
  };

  window.removeBundle = function (evt, bindId, key) {
    showLoader(true);
    cartChangeLine(key, 0, null)
      .then(function (parsed) {
        if (parsed && parsed.sections) applySectionsFromResponse(parsed);
        return bundleCartAjax(bindId);
      })
      .then(function (lastParsed) {
        if (lastParsed && lastParsed.sections) applySectionsFromResponse(lastParsed);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (e) {
        console.warn('[jsc bundle remove]', e);
      })
      .finally(function () {
        showLoader(false);
      });
  };

  window.pwpAddToCart = function (evt, discount2, discountType, index) {
    if (window.theme && theme.settings && theme.settings.hide_atc_button) return;
    var root = evt && evt.closest ? evt.closest('.jsc-promoSection') : null;
    if (!root) return;
    var c1 = root.querySelector('.jsc-pwp-col-1');
    var c2 = root.querySelector('.jsc-pwp-col-2');
    if (!c1 || !c2) return;
    var vid1 = parseInt(c1.getAttribute('data-vid'), 10);
    var vid2 = parseInt(c2.getAttribute('data-vid'), 10);
    var bindId = vid1 + '-' + vid2;
    var promo = String(index);
    var prop1 = { _PWP: 'Master', _BindID: bindId, '_Promo-No': promo };
    var prop2 = { _PWP: 'Child', _BindID: bindId, '_Promo-No': promo };
    showLoader(true);
    cartAddBundlePair(vid1, vid2, prop1, prop2)
      .then(function (parsed) {
        if (parsed && parsed.sections) applySectionsFromResponse(parsed);
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (e) {
        console.warn('[jsc pwp add]', e);
      })
      .finally(function () {
        showLoader(false);
      });
  };

  function stripPwpLineProperties(props) {
    var next = {};
    if (!props || typeof props !== 'object') return next;
    Object.keys(props).forEach(function (k) {
      if (
        k === '_Quantity-Promo' ||
        k === '_Off-Value' ||
        k === '_BindID' ||
        k === '_PWP' ||
        k === '_Promo-No'
      ) {
        return;
      }
      if (props[k] != null && props[k] !== '') {
        next[k] = props[k];
      }
    });
    return next;
  }

  /**
   * Remove only the clicked PWP line, then demote the partner line to a normal
   * item (drop PWP props) so the remaining item shows and charges as non–purchase-with-purchase.
   * @param {string|number} lineKey - Cart line key of the item whose remove was clicked
   */
  window.removePwp = function (evt, bindId, lineKey) {
    if (bindId == null || bindId === '' || lineKey == null || lineKey === '') {
      return;
    }
    showLoader(true);
    setTimeout(function () {
      var sKey = String(lineKey);
      fetchCartJson()
        .then(function (cart) {
          var found = findCartItemByKey(cart, sKey);
          if (!found || !found.item.properties) {
            return Promise.resolve(null);
          }
          if (String(found.item.properties._BindID) !== String(bindId)) {
            return Promise.resolve(null);
          }
          return cartChangeLine(sKey, 0, null).then(function () {
            return fetchCartJson().then(function (cart2) {
              var sibling = null;
              for (var i = 0; i < cart2.items.length; i++) {
                var it = cart2.items[i];
                if (!it.properties) continue;
                if (String(it.properties._BindID) !== String(bindId)) continue;
                if (it.properties._PWP !== 'Master' && it.properties._PWP !== 'Child') {
                  continue;
                }
                sibling = it;
                break;
              }
              if (!sibling) {
                return null;
              }
              var next = stripPwpLineProperties(sibling.properties);
              var sk = sibling.key;
              var sq = sibling.quantity;
              var svid = parseInt(sibling.variant_id, 10);
              if (Object.keys(next).length === 0) {
                return replaceBundleLine(sk, svid, sq);
              }
              return cartChangeLineReplaceProperties(sk, sq, next);
            });
          });
        })
        .then(function (lastParsed) {
          if (lastParsed && lastParsed.sections) {
            applySectionsFromResponse(lastParsed);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function (e) {
          console.warn('[jsc pwp remove]', e);
        })
        .finally(function () {
          showLoader(false);
        });
    }, 900);
  };

  window.updatePwp = function () {};

  window.pwpSetValidationPdp = function (setValue, $this) {
    if (!setValue || typeof $ === 'undefined' || !$this || !$this.parents) return;
    var v1 = $this.parents('.jsc-container').find('.jsc-pwp-col-1').attr('data-vid');
    var v2 = $this.parents('.jsc-container').find('.jsc-pwp-col-2').attr('data-vid');
    var bId = v1 + '-' + v2;
    var isInCart = false;
    fetchCartJson().then(function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var p = it.properties || {};
        if (String(p._BindID) === String(bId) && p._PWP === 'Child') {
          isInCart = true;
          if (it.quantity >= setValue) {
            $this.parents('.jsc-container').find('.jsc-set-limit-msg').show();
            $this.parents('.jsc-container').find('.jsc-atc-btn').hide();
          } else {
            $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
            $this.parents('.jsc-container').find('.jsc-atc-btn').show();
          }
        }
      }
      if (!isInCart) {
        $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
        $this.parents('.jsc-container').find('.jsc-atc-btn').show();
      }
    });
  };

  window.pwpSetValidationCart = function () {
    if (typeof $ === 'undefined') return;
    $('.jsc-pwp-container').each(function () {
      var $c = $(this);
      var setV = parseInt($c.attr('data-set'), 10) || 0;
      if (!setV) return;
      var v1 = $c.parents('.jsc-promoSection').find('.jsc-pwp-col-1').attr('data-vid');
      var v2 = $c.parents('.jsc-promoSection').find('.jsc-pwp-col-2').attr('data-vid');
      var bId = v1 + '-' + v2;
      var inCart = false;
      fetchCartJson().then(function (cart) {
        for (var j = 0; j < cart.items.length; j++) {
          var it = cart.items[j];
          var p = it.properties || {};
          if (String(p._BindID) === String(bId) && p._PWP === 'Child') {
            inCart = true;
            if (it.quantity >= setV) {
              $c.parents('.jsc-promoSection').find('.jsc-set-limit-msg').show();
              $c.parents('.jsc-promoSection').find('.jsc-atc-btn').hide();
            } else {
              $c.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
              $c.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
            }
          }
        }
        if (!inCart) {
          $c.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
          $c.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
        }
      });
    });
  };

  window.updateTolimitbundle = function () {};

  window.variantOption = function (evt, index, setValue) {
    var $this = $(evt);
    var $thisImgUrl = $this.find(':selected').attr('data-img');
    var $thisVid = $this.val();
    var $thisPrice = $this.find(':selected').attr('data-price');
    var $thisTitle = $this.find(':selected').text();
    var $thisComparePrice = $this.find(':selected').attr('data-compare-price');
    var $isDiscounted = $this.find(':selected').attr('data-settings-discount') == 'true';
    var $variantTitleEle = $this.parents('.jsc-promo-grid').find('span.jsc-variant-title');

    var $hiddenEle = $this.parents('.jsc-container').find('.jsc-hidden');
    var $discountType = $hiddenEle.val();
    var $minusPrice =
      $discountType == 'percentage-off'
        ? parseFloat($hiddenEle.attr('data-' + $discountType + '-' + index))
        : parseInt($hiddenEle.attr('data-' + $discountType + '-' + index), 10);

    $this.parents('.jsc-promo-grid').find('img').attr('src', $thisImgUrl);

    if ($isDiscounted) {
      var price = $thisComparePrice;
      var discountprice = $thisPrice;
      $this.siblings('.jsc-price').find('strike').text(price);
      $this.siblings('.jsc-price').find('span').text(discountprice);
    } else {
      if ($thisComparePrice) {
        var comparePrice = $thisComparePrice;
        $this.siblings('.jsc-price').find('strike').text(comparePrice);
        $this.siblings('.jsc-price').find('strike').show();
      } else {
        $this.siblings('.jsc-price').find('strike').hide();
      }
      var price = $thisPrice;
      $this.siblings('.jsc-price').find('span').text(price);
    }

    $this.parents('.jsc-promo-grid').attr('data-vid', $thisVid);

    if (setValue) {
      window.pwpSetValidationPdp(setValue, $this);
    }

    if ($variantTitleEle.length > 0) {
      $variantTitleEle.html($thisTitle);
    }
  };

  function runCartGiftPromo() {
    if (cartGiftBusy) return;
    if (Date.now() < cartGiftQuietUntil) return;

    var hasWork =
      document.querySelector('._cartGwp') ||
      document.querySelector('.jsc-cart-gift') ||
      document.querySelector('.jsc-cart-gift-upt') ||
      document.querySelector('.jsc-cart-gift-remove') ||
      document.querySelector('.jsc-remove-gwp') ||
      document.querySelector('.jsc-update-bundle-fix') ||
      document.querySelector('.jsc-remove-bundle');

    if (!hasWork) return;

    cartGiftBusy = true;
    showLoader(true);

    var chain = Promise.resolve(null);

    document.querySelectorAll('._cartGwp').forEach(function (el) {
      chain = chain.then(function () {
        return processOneTierGwp(el);
      });
    });

    chain = runCartGiftLines(chain);

    document.querySelectorAll('.jsc-remove-gwp').forEach(function (el) {
      var key = el.value;
      chain = chain.then(function () {
        return cartChangeLine(key, 0, null);
      });
    });

    chain = updateBundleLimitsChain(chain);
    chain = removeDisabledBundleChain(chain);

    chain
      .then(function (lastParsed) {
        if (lastParsed && lastParsed.sections) {
          applySectionsFromResponse(lastParsed);
        }
        cartGiftQuietUntil = Date.now() + 1400;
      })
      .catch(function (e) {
        console.warn('[jsc cart gwp]', e);
      })
      .finally(function () {
        cartGiftBusy = false;
        showLoader(false);
      });
  }

  function scheduleCartGift() {
    if (cartGiftTimer) clearTimeout(cartGiftTimer);
    cartGiftTimer = setTimeout(function () {
      cartGiftTimer = null;
      runCartGiftPromo();
    }, cartGiftDebounceMs);
  }

  ['cart:refresh', 'cart:item-added', 'line-item:change:end'].forEach(function (evt) {
    document.addEventListener(evt, scheduleCartGift);
  });

  function schedulePwpPdp() {
    if (typeof window.pwpSetValidationCart === 'function') {
      window.pwpSetValidationCart();
    }
  }
  ['cart:refresh', 'cart:item-added', 'line-item:change:end'].forEach(function (evt) {
    document.addEventListener(evt, schedulePwpPdp);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCartGift);
  } else {
    scheduleCartGift();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePwpPdp);
  } else {
    schedulePwpPdp();
  }
})();

/**
 * 1440px+ wrap menu+social, then build .jsc-footer-right-column (2nd: menu-social on top, payment below).
 * <1440: dismantle right column, restore default DOM. See jsc-footer-right-column in CSS.
 */
initJscFooterWideLayout = function () {
  var ROW_GROUPED = 'jsc-footer-row-1--wide-grouped';
  var WRAP_CLASS = 'jsc-footer-menu-social';
  var DATA_IDX = 'data-jsc-footer-orig-idx';
  var mq = window.matchMedia('(min-width: 1200px)');

  function getRow() {
    var el = document.querySelector('.jsc-footer-section .jsc-footer-row-1');
    return el || null;
  }

  var RIGHT_COL = 'jsc-footer-right-column';
  var RIGHT_COL_ATTR = 'data-jsc-footer-right-column';

  function getThemePaymentIcons() {
    return document.querySelector('.jsc-footer-section [data-jsc-theme-payment-icons]') || null;
  }

  function getRightColumn(row) {
    if (!row) {
      return null;
    }
    return row.querySelector('[' + RIGHT_COL_ATTR + ']') || null;
  }

  function moveThemePaymentIconsToDefault() {
    var pay = getThemePaymentIcons();
    if (!pay) {
      return;
    }
    var foot = pay.closest && pay.closest('.jsc-footer-section');
    if (!foot) {
      return;
    }
    var row2 = foot.querySelector('.jsc-footer-row-2');
    if (!row2) {
      return;
    }
    if (pay === row2.previousElementSibling) {
      return;
    }
    foot.insertBefore(pay, row2);
  }

  function assembleRightColumn(row) {
    if (!row) {
      return;
    }
    var menuSocial = row.querySelector('.' + WRAP_CLASS);
    if (!menuSocial) {
      return;
    }
    var pay = getThemePaymentIcons();
    var right = getRightColumn(row);
    if (!right) {
      right = document.createElement('div');
      right.className = RIGHT_COL;
      right.setAttribute(RIGHT_COL_ATTR, '');
      row.insertBefore(right, menuSocial);
    }
    if (menuSocial.parentNode !== right) {
      right.appendChild(menuSocial);
      if (pay) {
        right.appendChild(pay);
      }
    } else {
      if (pay && !right.contains(pay)) {
        right.appendChild(pay);
      } else if (pay && right.contains(pay) && right.contains(menuSocial) && right.firstElementChild === pay) {
        right.insertBefore(menuSocial, pay);
      }
    }
  }

  function dismantleRightColumn(row) {
    if (!row) {
      return;
    }
    var right = getRightColumn(row);
    if (!right) {
      return;
    }
    var foot = row.parentNode;
    var row2 = foot && foot.querySelector ? foot.querySelector('.jsc-footer-row-2') : null;
    var pay = getThemePaymentIcons();
    var menuSocial = right.querySelector('.' + WRAP_CLASS) || null;

    if (menuSocial) {
      row.insertBefore(menuSocial, right);
    }
    if (pay && right.contains(pay) && row2) {
      foot.insertBefore(pay, row2);
    } else if (pay && right.contains(pay) && !row2) {
      if (row.nextSibling) {
        foot.insertBefore(pay, row.nextSibling);
      } else {
        foot.appendChild(pay);
      }
    }
    if (right.parentNode) {
      right.remove();
    }
  }

  function getDirectMenuSocialNodes(row) {
    if (typeof row.querySelectorAll !== 'function') return [];
    try {
      return Array.prototype.slice.call(
        row.querySelectorAll(':scope > .columns.footer-menu, :scope > .columns.footer-social')
      );
    } catch (e) {
      return Array.prototype.slice.call(row.children).filter(function (el) {
        return (
          el.classList &&
          el.classList.contains('columns') &&
          (el.classList.contains('footer-menu') || el.classList.contains('footer-social'))
        );
      });
    }
  }

  function wrapRow(row) {
    if (!row) return;
    if (row.classList.contains(ROW_GROUPED) && row.querySelector('.' + WRAP_CLASS)) {
      return;
    }
    var toWrap = getDirectMenuSocialNodes(row);
    if (!toWrap.length) return;
    if (row.querySelector('.' + WRAP_CLASS)) {
      row.classList.add(ROW_GROUPED);
      return;
    }

    var byIdx = toWrap
      .map(function (el) {
        return { el: el, idx: Array.prototype.indexOf.call(row.children, el) };
      })
      .filter(function (x) {
        return x.idx >= 0;
      })
      .sort(function (a, b) {
        return a.idx - b.idx;
      });
    if (!byIdx.length) return;

    byIdx.forEach(function (x) {
      x.el.setAttribute(DATA_IDX, String(x.idx));
    });

    var first = byIdx[0].el;
    var wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;
    row.insertBefore(wrap, first);
    byIdx.forEach(function (x) {
      wrap.appendChild(x.el);
    });
    row.classList.add(ROW_GROUPED);
  }

  function unwrapRow(row) {
    if (!row) return;
    var wrap = row.querySelector('.' + WRAP_CLASS);
    if (!wrap) {
      row.classList.remove(ROW_GROUPED);
      return;
    }

    var ch = Array.prototype.slice.call(wrap.children).filter(function (el) {
      return el.hasAttribute(DATA_IDX);
    });
    ch.sort(function (a, b) {
      return (
        parseInt(a.getAttribute(DATA_IDX) || '0', 10) - parseInt(b.getAttribute(DATA_IDX) || '0', 10)
      );
    });
    var anchor = wrap.nextElementSibling;
    for (var k = ch.length - 1; k >= 0; k--) {
      row.insertBefore(ch[k], anchor);
    }
    ch.forEach(function (el) {
      el.removeAttribute(DATA_IDX);
    });
    wrap.remove();
    row.classList.remove(ROW_GROUPED);
  }

  function apply() {
    var row = getRow();
    if (!row) {
      return;
    }
    if (mq.matches) {
      wrapRow(row);
      assembleRightColumn(row);
    } else {
      dismantleRightColumn(row);
      moveThemePaymentIconsToDefault();
      unwrapRow(row);
    }
  }

  if (!initJscFooterWideLayout.jscInitDone) {
    initJscFooterWideLayout.jscInitDone = true;
    var resizeTimer = null;
    window.addEventListener(
      'resize',
      function () {
        if (resizeTimer) {
          clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(function () {
          resizeTimer = null;
          apply();
        }, 150);
      },
      { passive: true }
    );
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(apply);
    }
  }

  apply();
};

/**
 * ≤798px: stack Lacoste footer blocks as accordions (native <details>), matching Menu block behaviour.
 * Overrides theme-footer (footer.js) which toggles at 768px — we sync all <details> in .jsc-footer-section at 798px.
 * Wraps non-menu columns (except footer-signup and footer-social) in <details> on mobile; restores DOM on desktop.
 */
initJscFooterMobileAccordion = function () {
  var BP = 798;
  var mq =
    typeof window.matchMedia === 'function'
      ? window.matchMedia('(max-width: ' + BP + 'px)')
      : { matches: window.innerWidth <= BP, addEventListener: null, addListener: null };
  var ARROW =
    '<span><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function getFooter() {
    return document.querySelector('.jsc-footer-section');
  }

  function getFooterColumns(row) {
    if (!row || typeof row.querySelectorAll !== 'function') {
      return [];
    }
    var result = [];
    function walk(el) {
      if (!el || !el.children) {
        return;
      }
      Array.prototype.slice.call(el.children).forEach(function (child) {
        if (!child.classList) {
          return;
        }
        if (child.classList.contains('columns')) {
          result.push(child);
        } else if (
          child.classList.contains('jsc-footer-menu-social') ||
          child.getAttribute('data-jsc-footer-right-column') !== null
        ) {
          walk(child);
        }
      });
    }
    walk(row);
    return result;
  }

  function syncDetailsOpenState(foot) {
    if (!foot) {
      return;
    }
    var desktop = window.innerWidth > BP;
    foot.querySelectorAll('details').forEach(function (d) {
      if (desktop) {
        d.setAttribute('open', '');
      } else {
        d.removeAttribute('open');
      }
    });
  }

  function fallbackTitle(col) {
    if (col.classList.contains('footer-custom-liquid')) {
      return 'More';
    }
    return 'Information';
  }

  function wrapColumn(col) {
    if (!col || col.getAttribute('data-jsc-footer-mobile-accordion') === 'true') {
      return;
    }
    if (col.classList.contains('footer-menu')) {
      return;
    }
    if (col.classList.contains('footer-signup')) {
      return;
    }
    if (col.classList.contains('footer-social')) {
      return;
    }

    var titleEl = col.querySelector('.thb-widget-title');
    var summary = document.createElement('summary');
    summary.className = 'thb-widget-title collapsible jsc-footer-mobile-summary';
    summary.setAttribute('tabindex', '0');

    var titleMeta = null;
    if (titleEl) {
      titleMeta = {
        node: titleEl,
        parent: titleEl.parentNode,
        nextSibling: titleEl.nextSibling
      };
      summary.innerHTML = titleEl.innerHTML + ARROW;
      titleEl.remove();
    } else {
      summary.innerHTML = fallbackTitle(col) + ARROW;
    }

    var inner = document.createElement('div');
    inner.className = 'jsc-footer-mobile-accordion__content';

    while (col.firstChild) {
      inner.appendChild(col.firstChild);
    }

    var details = document.createElement('details');
    details.className = 'jsc-footer-mobile-accordion';
    details.appendChild(summary);
    details.appendChild(inner);
    if (titleMeta) {
      details._jscFooterTitleMeta = titleMeta;
    }

    col.appendChild(details);
    col.setAttribute('data-jsc-footer-mobile-accordion', 'true');
  }

  function unwrapColumn(col) {
    var details = col.querySelector(':scope > .jsc-footer-mobile-accordion');
    if (!details) {
      col.removeAttribute('data-jsc-footer-mobile-accordion');
      return;
    }

    var inner = details.querySelector('.jsc-footer-mobile-accordion__content');
    var meta = details._jscFooterTitleMeta;

    if (inner) {
      while (inner.firstChild) {
        col.insertBefore(inner.firstChild, details);
      }
    }

    if (meta && meta.node && meta.parent) {
      meta.parent.insertBefore(meta.node, meta.nextSibling);
    }

    details.remove();
    col.removeAttribute('data-jsc-footer-mobile-accordion');
  }

  function apply() {
    var foot = getFooter();
    if (!foot) {
      return;
    }

    var isMobile = typeof mq.matches !== 'undefined' ? mq.matches : window.innerWidth <= BP;
    foot.classList.toggle('jsc-footer--mobile-accordion', isMobile);

    var row = foot.querySelector('.jsc-footer-row-1');
    if (!row) {
      syncDetailsOpenState(foot);
      return;
    }

    var cols = getFooterColumns(row);
    if (isMobile) {
      cols.forEach(wrapColumn);
    } else {
      cols.forEach(unwrapColumn);
    }

    syncDetailsOpenState(foot);
  }

  if (!initJscFooterMobileAccordion._listeners) {
    initJscFooterMobileAccordion._listeners = true;
    var resizeTimer = null;
    window.addEventListener(
      'resize',
      function () {
        if (resizeTimer) {
          clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(function () {
          resizeTimer = null;
          apply();
        }, 50);
      },
      { passive: true }
    );
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(apply);
    }
  }

  apply();
};

/* start:: product siblings drawer in PDP + variant colour drawer (same open/reset behaviour) */
function jscOpenPsDrawerPanel(el) {
  if (!el || el.classList.contains('active')) {
    return;
  }

  function jscResetPsFamilyFilterRoot(root) {
    if (!root || !root.querySelector) {
      return;
    }
    var panels = root.querySelectorAll('[data-jsc-ps-tab-panel]');
    if (panels.length) {
      panels.forEach(function (panel) {
        panel.querySelectorAll('.jsc-ps-drawer__cell').forEach(function (c) {
          c.removeAttribute('hidden');
          c.classList.remove('jsc-ps-filtered-out');
        });
        if (panel.querySelector('.jsc-ps-drawer__filter')) {
          panel.querySelectorAll('[data-jsc-ps-filter]').forEach(function (b) {
            var isAll = b.getAttribute('data-jsc-ps-filter') === 'all';
            b.classList.toggle('jsc-ps-filter-btn--active', isAll);
            b.setAttribute('aria-pressed', isAll ? 'true' : 'false');
          });
        }
      });
    } else {
      if (!root.querySelector('.jsc-ps-drawer__filter')) {
        return;
      }
      root.querySelectorAll('.jsc-ps-drawer__cell').forEach(function (c) {
        c.removeAttribute('hidden');
        c.classList.remove('jsc-ps-filtered-out');
      });
      root.querySelectorAll('[data-jsc-ps-filter]').forEach(function (b) {
        var isAll = b.getAttribute('data-jsc-ps-filter') === 'all';
        b.classList.toggle('jsc-ps-filter-btn--active', isAll);
        b.setAttribute('aria-pressed', isAll ? 'true' : 'false');
      });
    }
  }

  function jscResetPsVarTabSwitch(root) {
    if (!root || !root.querySelector || !root.querySelector('.jsc-ps-drawer__filter-var')) {
      return;
    }
    var p1 = root.querySelector('[data-jsc-ps-tab-panel="1"]');
    var p2 = root.querySelector('[data-jsc-ps-tab-panel="2"]');
    if (p1) {
      p1.hidden = false;
    }
    if (p2) {
      p2.hidden = true;
    }
    root.querySelectorAll('.jsc-ps-filter-btn-var').forEach(function (b) {
      var t = b.getAttribute('data-tab') || b.getAttribute('data-jsc-ps-var-tab');
      var isFirst = t === '1';
      b.classList.toggle('jsc-ps-filter-btn-var--active', isFirst);
      b.setAttribute('aria-pressed', isFirst ? 'true' : 'false');
    });
  }

  function openNow() {
    document.body.classList.add('open-cc', 'overflow-hidden');
    el.classList.add('active');
    el.removeAttribute('inert');
    jscResetPsFamilyFilterRoot(el);
    jscResetPsVarTabSwitch(el);
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  document.body.appendChild(el);
  void el.offsetWidth;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    openNow();
    return;
  }

  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      openNow();
    });
  });
}

window.jscProdSiblingsDrawer = function jscProdSiblingsDrawer(blockId) {
  var el = document.getElementById('Jsc-Product-Siblings-Drawer-' + String(blockId));
  jscOpenPsDrawerPanel(el);
};

window.jscVariantColorDrawer = function jscVariantColorDrawer(sectionId) {
  var el = document.getElementById('Jsc-Variant-Color-Drawer-' + String(sectionId));
  jscOpenPsDrawerPanel(el);
};

(function jscInitVariantColorDrawerPick() {
  if (window.jscVariantColorDrawerPickBound) {
    return;
  }
  window.jscVariantColorDrawerPickBound = true;
  document.addEventListener(
    'click',
    function (e) {
      var cell = e.target.closest && e.target.closest('[data-jsc-variant-color-select]');
      if (!cell) {
        return;
      }
      var dr = cell.closest('[data-jsc-variant-color-drawer]');
      if (!dr) {
        return;
      }
      e.preventDefault();
      var sid = cell.getAttribute('data-section-id');
      var colorVal = cell.getAttribute('data-jsc-group-value');
      if (sid == null || colorVal == null) {
        return;
      }
      document.dispatchEvent(
        new CustomEvent('jsc-variant-color-drawer-pick', {
          detail: { sectionId: String(sid), colorValue: colorVal }
        })
      );
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('panel:close');
      } else {
        document.dispatchEvent(new CustomEvent('panel:close'));
      }
    },
    false
  );
})();

/**
 * Sibling drawer: colour family filters (metaobject colour_base_name vs category Color metafield on products).
 */
(function jscInitProductSiblingsDrawerFilter() {
  if (window.jscPsDrawerFilterBound) {
    return;
  }
  window.jscPsDrawerFilterBound = true;
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.jsc-ps-drawer [data-jsc-ps-filter]');
      if (!btn) {
        return;
      }
      var filterVal = (btn.getAttribute('data-jsc-ps-filter') || 'all').trim();
      var root = btn.closest('.jsc-ps-drawer');
      if (!root) {
        return;
      }
      var panel = btn.closest('[data-jsc-ps-tab-panel]');
      if (!panel) {
        return;
      }
      e.preventDefault();
      panel.querySelectorAll('[data-jsc-ps-filter]').forEach(function (b) {
        var isActive = b === btn;
        b.classList.toggle('jsc-ps-filter-btn--active', isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      var cells = panel.querySelectorAll('.jsc-ps-drawer__cell');
      if (filterVal === 'all') {
        cells.forEach(function (cell) {
          cell.removeAttribute('hidden');
          cell.classList.remove('jsc-ps-filtered-out');
        });
        return;
      }
      cells.forEach(function (cell) {
        var famAttr = (
          cell.getAttribute('data-jsc-ps-families') ||
          cell.getAttribute('data-jsc-ps-family') ||
          ''
        ).trim();
        if (!famAttr || famAttr === 'none') {
          cell.setAttribute('hidden', 'hidden');
          cell.classList.add('jsc-ps-filtered-out');
          return;
        }
        var show = false;
        var handles = famAttr.split(/\s+/);
        for (var i = 0; i < handles.length; i++) {
          if (handles[i] === filterVal) {
            show = true;
            break;
          }
        }
        if (show) {
          cell.removeAttribute('hidden');
          cell.classList.remove('jsc-ps-filtered-out');
        } else {
          cell.setAttribute('hidden', 'hidden');
          cell.classList.add('jsc-ps-filtered-out');
        }
      });
    },
    false
  );
})();

/**
 * Sibling drawer: top-level “All colours” / “Variations” tabs (product_title vs product_title_variants).
 */
(function jscInitProductSiblingsDrawerVarTabs() {
  if (window.jscPsDrawerVarTabBound) {
    return;
  }
  window.jscPsDrawerVarTabBound = true;
  document.addEventListener(
    'click',
    function (e) {
      var vbtn = e.target.closest && e.target.closest('.jsc-ps-drawer .jsc-ps-filter-btn-var');
      if (!vbtn) {
        return;
      }
      var root = vbtn.closest('.jsc-ps-drawer');
      if (!root) {
        return;
      }
      e.preventDefault();
      var tab = vbtn.getAttribute('data-tab') || vbtn.getAttribute('data-jsc-ps-var-tab');
      if (!tab) {
        return;
      }
      var p1 = root.querySelector('[data-jsc-ps-tab-panel="1"]');
      var p2 = root.querySelector('[data-jsc-ps-tab-panel="2"]');
      if (tab === '1') {
        if (p1) {
          p1.hidden = false;
        }
        if (p2) {
          p2.hidden = true;
        }
      } else if (tab === '2') {
        if (p1) {
          p1.hidden = true;
        }
        if (p2) {
          p2.hidden = false;
        }
      }
      root.querySelectorAll('.jsc-ps-filter-btn-var').forEach(function (b) {
        var t = b.getAttribute('data-tab') || b.getAttribute('data-jsc-ps-var-tab');
        var isActive = t === tab;
        b.classList.toggle('jsc-ps-filter-btn-var--active', isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    },
    false
  );
})();

/**
 * PDP sibling thumbnail row: hovering a .jsc-ps-card-1 shows that product’s color-pattern label in .jsc-selected-product-siblings.
 */
(function jscInitProductSiblingColorHoverPreview() {
  if (window.jscPsSiblingColorHoverBound) {
    return;
  }
  window.jscPsSiblingColorHoverBound = true;

  function jscRestoreSiblingColorLabel(out) {
    if (!out) {
      return;
    }
    var d = out.getAttribute('data-jsc-sibling-color-default');
    out.textContent = d == null ? '' : d;
  }

  document.addEventListener(
    'mouseover',
    function (e) {
      if (!e.target || !e.target.closest) {
        return;
      }
      var card = e.target.closest('.jsc-product-siblings .jsc-ps-card-1[data-jsc-sibling-hover-color]');
      if (!card) {
        return;
      }
      var root = card.closest('.jsc-product-siblings');
      if (!root) {
        return;
      }
      var out = root.querySelector('.jsc-selected-product-siblings');
      if (!out) {
        return;
      }
      var hover = card.getAttribute('data-jsc-sibling-hover-color');
      if (hover == null || hover === '') {
        return;
      }
      out.textContent = hover;
    },
    false
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      if (!e.target || !e.target.closest) {
        return;
      }
      var card = e.target.closest('.jsc-product-siblings .jsc-ps-card-1[data-jsc-sibling-hover-color]');
      if (!card) {
        return;
      }
      var rt = e.relatedTarget;
      if (rt && card.contains(rt)) {
        return;
      }
      var root = card.closest('.jsc-product-siblings');
      if (!root) {
        return;
      }
      jscRestoreSiblingColorLabel(root.querySelector('.jsc-selected-product-siblings'));
    },
    false
  );
})();

/**
 * PDP variant picker: hovering a colour card shows that colour’s pattern label in .jsc-variant-picker__label.
 */
(function jscInitVariantPickerColorHoverPreview() {
  if (window.jscVpColorHoverBound) {
    return;
  }
  window.jscVpColorHoverBound = true;

  function jscRestoreVariantPickerColorLabel(out) {
    if (!out) {
      return;
    }
    var d = out.getAttribute('data-jsc-variant-color-default');
    out.textContent = d == null ? '' : d;
  }

  function jscVariantPickerLabelForHoverTarget(target) {
    if (!target || !target.closest) {
      return null;
    }
    var btn = target.closest('[data-jsc-variant-hover-color]');
    if (!btn) {
      return null;
    }
    var hover = btn.getAttribute('data-jsc-variant-hover-color');
    if (hover == null || hover === '') {
      return null;
    }
    var out = null;
    var head = btn.closest('.jsc-variant-picker__color-head');
    if (head) {
      out = head.querySelector('.jsc-variant-picker__label');
    }
    if (!out) {
      var dr = btn.closest('[data-jsc-variant-color-drawer]');
      var sid = btn.getAttribute('data-section-id');
      if (dr && sid) {
        out = document.getElementById('jsc-variant-picker-label-' + sid);
      }
    }
    if (!out) {
      return null;
    }
    return { out: out, hover: hover, btn: btn };
  }

  document.addEventListener(
    'mouseover',
    function (e) {
      var ctx = jscVariantPickerLabelForHoverTarget(e.target);
      if (!ctx) {
        return;
      }
      ctx.out.textContent = ctx.hover;
    },
    false
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      var ctx = jscVariantPickerLabelForHoverTarget(e.target);
      if (!ctx) {
        return;
      }
      var rt = e.relatedTarget;
      if (rt && ctx.btn.contains(rt)) {
        return;
      }
      jscRestoreVariantPickerColorLabel(ctx.out);
    },
    false
  );
})();

/**
 * Quick-view product drawer: sibling colour cells swap in another product (variants + ATC) without leaving the drawer.
 * PDP “Select a colour” side panel keeps normal <a href> navigation.
 */
(function jscInitQuickViewSiblingCellSwitch() {
  if (window.jscQvSiblingSwitchBound) {
    return;
  }
  window.jscQvSiblingSwitchBound = true;

  window.jscReloadQuickViewProduct = function jscReloadQuickViewProduct(productHandle) {
    var drawer = document.getElementById('Product-Drawer');
    var container = document.getElementById('Product-Drawer-Content');
    if (!drawer || !container || !productHandle || !window.theme || !window.theme.routes) {
      return;
    }

    var vs = container.querySelector('variant-selects');
    if (vs && vs.dataset && vs.dataset.url) {
      try {
        var parts = vs.dataset.url.split('/products/');
        if (parts.length > 1) {
          var cur = parts[1].split('?')[0];
          if (cur === productHandle) {
            return;
          }
        }
      } catch (e1) {}
    }

    if (window.jscQvSiblingSwitchLoading) {
      return;
    }
    window.jscQvSiblingSwitchLoading = true;
    drawer.classList.add('jsc-qv-switch-loading');

    var root = window.theme.routes.root_url || '';
    var href =
      (root.endsWith('/') ? root.slice(0, -1) : root) +
      '/products/' +
      encodeURIComponent(productHandle) +
      '?view=quick-view';

    fetch(href, { method: 'GET', credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var inner = doc.querySelector('#Product-Drawer-Content');
        if (!inner) {
          return;
        }
        container.innerHTML = inner.innerHTML;

        var jsFiles = container.querySelectorAll('script[src]');
        if (jsFiles.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          jsFiles.forEach(function (jsFile) {
            var src = jsFile.getAttribute('src');
            if (!src) {
              return;
            }
            var script = document.createElement('script');
            script.src = src;
            head.appendChild(script);
          });
        }

        setTimeout(function () {
          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('quick-view:open', {
            productUrl: href,
            productHandle: productHandle,
          });
        } else {
          document.dispatchEvent(
            new CustomEvent('quick-view:open', {
              detail: { productUrl: href, productHandle: productHandle },
            })
          );
        }

        if (typeof addIdToRecentlyViewed === 'function') {
          addIdToRecentlyViewed(productHandle);
        }

        document.dispatchEvent(new CustomEvent('jsc:product-drawer-content-updated', { bubbles: true }));
      })
      .catch(function () {})
      .finally(function () {
        window.jscQvSiblingSwitchLoading = false;
        drawer.classList.remove('jsc-qv-switch-loading');
      });
  };

  document.addEventListener(
    'click',
    function (e) {
      var cell = e.target.closest('.jsc-ps-drawer__cell--qv-switch');
      if (!cell) {
        return;
      }
      var pd = document.getElementById('Product-Drawer');
      if (!pd || !pd.contains(cell)) {
        return;
      }
      var handle = cell.getAttribute('data-product-handle');
      if (!handle) {
        return;
      }
      e.preventDefault();
      window.jscReloadQuickViewProduct(handle);
    },
    false
  );
})();

/**
 * Product drawer (quick view): Flickity syncs with left column thumbnails (product-thumbnails.js).
 * This file builds mobile (≤798px) dot pagination; desktop thumbnail strip scroll + arrow nav lives here too.
 */
function initJscProductDrawerGallery() {
  if (window.jscProductDrawerGalleryInitDone) {
    return;
  }
  window.jscProductDrawerGalleryInitDone = true;
  initJscProductDrawerThumbNav();
  document.addEventListener('quick-view:open', function () {
    requestAnimationFrame(function () {
      jscScheduleProductDrawerDotsBind();
      jscSyncProductDrawerThumbShell();
      document.dispatchEvent(new CustomEvent('jsc:product-drawer-content-updated', { bubbles: true }));
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        jscScheduleProductDrawerDotsBind();
        jscSyncProductDrawerThumbShell();
      },
      { once: true }
    );
  } else {
    jscScheduleProductDrawerDotsBind();
    jscSyncProductDrawerThumbShell();
  }
  var drawerContent = document.getElementById('Product-Drawer-Content');
  if (drawerContent && typeof MutationObserver !== 'undefined') {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        jscScheduleProductDrawerDotsBind();
        jscSyncProductDrawerThumbShell();
      }, 80);
    }).observe(drawerContent, { childList: true, subtree: true });
  }
}

function initJscProductDrawerThumbNav() {
  if (window.jscProductDrawerThumbNavInit) {
    return;
  }
  window.jscProductDrawerThumbNavInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jsc-qd-thumb-nav]');
    if (!btn) {
      return;
    }
    var content = document.getElementById('Product-Drawer-Content');
    if (!content || !content.contains(btn)) {
      return;
    }
    if (btn.disabled) {
      return;
    }
    var dir = btn.getAttribute('data-jsc-qd-thumb-nav');
    var tray = document.getElementById('Product-Thumbnails-Drawer');
    if (!tray) {
      return;
    }
    var host =
      tray.closest('.jsc-product-drawer-gallery') ||
      tray.closest('#Product-Drawer-Content') ||
      document.documentElement;
    var raw = getComputedStyle(host).getPropertyValue('--jsc-qd-thumb-size');
    var gapRaw = getComputedStyle(host).getPropertyValue('--jsc-qd-thumb-gap');
    var thumbPx = parseFloat(raw);
    var gapPx = parseFloat(gapRaw);
    var step =
      (isNaN(thumbPx) ? 44 : thumbPx) + (isNaN(gapPx) ? 8 : gapPx);
    tray.scrollTop += dir === 'prev' ? -step : step;
    requestAnimationFrame(function () {
      jscRefreshProductDrawerThumbNav();
    });
  });
}

function jscEnsureThumbDrawerScrollSync() {
  var tray = document.getElementById('Product-Thumbnails-Drawer');
  if (!tray || tray.dataset.jscThumbNavScrollBound === 'true') {
    return;
  }
  tray.dataset.jscThumbNavScrollBound = 'true';
  tray.addEventListener('scroll', function () {
    jscRefreshProductDrawerThumbNav();
  });
}

function jscCountProductDrawerThumbs() {
  var tray = document.getElementById('Product-Thumbnails-Drawer');
  if (!tray) {
    return 0;
  }
  return tray.querySelectorAll('.product-thumbnail').length;
}

function jscRefreshProductDrawerThumbNav() {
  var tray = document.getElementById('Product-Thumbnails-Drawer');
  if (!tray) {
    return;
  }
  var shell = tray.closest('.jsc-product-drawer-gallery__thumbs-shell');
  if (!shell) {
    return;
  }
  var prev = shell.querySelector('[data-jsc-qd-thumb-nav="prev"]');
  var next = shell.querySelector('[data-jsc-qd-thumb-nav="next"]');
  var thumbCount = jscCountProductDrawerThumbs();
  var showNav = thumbCount > 6;
  shell.classList.toggle('jsc-product-drawer-gallery__thumbs-shell--static', !showNav);
  if (prev) {
    prev.hidden = !showNav;
    prev.style.display = showNav ? '' : 'none';
  }
  if (next) {
    next.hidden = !showNav;
    next.style.display = showNav ? '' : 'none';
  }
  if (!prev || !next || !showNav) {
    return;
  }
  var maxScroll = Math.max(0, tray.scrollHeight - tray.clientHeight);
  var tol = 2;
  var top = tray.scrollTop;
  prev.disabled = top <= tol;
  next.disabled = top >= maxScroll - tol;
}

function jscSyncProductDrawerThumbShell() {
  jscEnsureThumbDrawerScrollSync();
  requestAnimationFrame(function () {
    jscRefreshProductDrawerThumbNav();
  });
  setTimeout(function () {
    jscRefreshProductDrawerThumbNav();
  }, 150);
}

function jscScheduleProductDrawerDotsBind() {
  var attempts = 0;
  var maxAttempts = 150;
  function tick() {
    var slider = document.querySelector('#Product-Drawer-Content #Product-Slider');
    if (slider && slider.dataset.jscQdDotsBound === 'true') {
      return;
    }
    jscAttemptProductDrawerDotsBind();
    slider = document.querySelector('#Product-Drawer-Content #Product-Slider');
    if (slider && slider.dataset.jscQdDotsBound === 'true') {
      return;
    }
    attempts++;
    if (attempts < maxAttempts) {
      requestAnimationFrame(tick);
    }
  }
  tick();
}

function jscAttemptProductDrawerDotsBind() {
  var root = document.getElementById('Product-Drawer-Content');
  if (!root || !root.querySelector('.jsc-product-drawer-gallery')) {
    return;
  }
  var slider = root.querySelector('#Product-Slider');
  var dotsRoot = root.querySelector('[data-jsc-qd-dots]');
  if (!slider || !dotsRoot) {
    return;
  }
  if (slider.dataset.jscQdDotsBound === 'true') {
    return;
  }
  if (!window.Flickity || typeof window.Flickity.data !== 'function') {
    return;
  }
  var flkty = window.Flickity.data(slider);
  if (!flkty) {
    return;
  }

  slider.dataset.jscQdDotsBound = 'true';

  function rebuildDots() {
    dotsRoot.innerHTML = '';
    var n = flkty.cells ? flkty.cells.length : 0;
    if (n <= 1) {
      dotsRoot.hidden = true;
      dotsRoot.setAttribute('aria-hidden', 'true');
      return;
    }
    dotsRoot.hidden = false;
    dotsRoot.removeAttribute('aria-hidden');
    for (var i = 0; i < n; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jsc-product-drawer-gallery__dot';
      btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
      btn.setAttribute('data-index', String(i));
      if (i === flkty.selectedIndex) {
        btn.classList.add('is-selected');
        btn.setAttribute('aria-current', 'true');
      }
      dotsRoot.appendChild(btn);
    }
  }

  function syncDots() {
    var idx = flkty.selectedIndex;
    var btns = dotsRoot.querySelectorAll('.jsc-product-drawer-gallery__dot');
    for (var i = 0; i < btns.length; i++) {
      var on = i === idx;
      btns[i].classList.toggle('is-selected', on);
      if (on) {
        btns[i].setAttribute('aria-current', 'true');
      } else {
        btns[i].removeAttribute('aria-current');
      }
    }
  }

  dotsRoot.addEventListener('click', function jscOnProductDrawerDotsClick(e) {
    var btn = e.target.closest('.jsc-product-drawer-gallery__dot');
    if (!btn || !dotsRoot.contains(btn)) {
      return;
    }
    var ix = parseInt(btn.getAttribute('data-index'), 10);
    if (!isNaN(ix)) {
      flkty.select(ix);
    }
  });

  flkty.on('change', syncDots);
  rebuildDots();
  syncDots();
}
/* end:: product siblings drawer in PDP */

/**
 * Product drawer (quick view): wishlist icon 24×24 + Swym add/remove (same API pattern as cart-drawer).
 */
(function jscInitProductDrawerWishlist() {
  if (window.jscProductDrawerWishlistBound) {
    return;
  }
  window.jscProductDrawerWishlistBound = true;

  var qvWishlistListId = null;
  var qvWishlistEvtBound = false;

  function jscQvWishlistRoot() {
    return document.getElementById('Product-Drawer-Content');
  }

  function jscQvSetWishlistState(btn, isOn) {
    var s = isOn ? 'true' : 'false';
    btn.dataset.jscWishlistAdded = s;
    btn.setAttribute('aria-pressed', s);
    btn.classList.toggle('swym-added', !!isOn);
  }

  function jscQvSetWishlistLoading(btn, on) {
    btn.classList.toggle('swym-loading', !!on);
    if (on) {
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('aria-busy');
    }
  }

  function jscQvEnsureWishlistListId(swat) {
    if (qvWishlistListId) {
      return Promise.resolve(qvWishlistListId);
    }
    return new Promise(function (resolve) {
      swat.fetchLists({
        callbackFn: function (lists) {
          var wishlist = (lists || []).find(function (list) {
            return list && (list.lty === 'wl' || list.lty === null || typeof list.lty === 'undefined');
          });
          if (wishlist && wishlist.lid) {
            qvWishlistListId = wishlist.lid;
            resolve(qvWishlistListId);
            return;
          }
          if (typeof swat.createList === 'function') {
            swat.createList(
              { lname: 'My Wishlist' },
              function (createdList) {
                qvWishlistListId = createdList && createdList.lid ? createdList.lid : null;
                resolve(qvWishlistListId);
              },
              function () {
                resolve(null);
              }
            );
            return;
          }
          resolve(null);
        },
        errorFn: function () {
          resolve(null);
        },
      });
    });
  }

  function jscQvUpdateFromSwymEvent(epi, empi, isOn) {
    if (!epi || !empi) {
      return;
    }
    var root = jscQvWishlistRoot();
    if (!root) {
      return;
    }
    root.querySelectorAll('[data-jsc-qv-wishlist-button="true"]').forEach(function (btn) {
      if (String(btn.dataset.variantId) === String(epi) && String(btn.dataset.productId) === String(empi)) {
        jscQvSetWishlistState(btn, isOn);
      }
    });
  }

  function jscQvBindSwymEvtLayer(swat) {
    if (!swat || !swat.evtLayer || qvWishlistEvtBound) {
      return;
    }
    swat.evtLayer.addEventListener('sw:addedtowishlist', function (e) {
      var d = e && e.detail && e.detail.d ? e.detail.d : {};
      jscQvUpdateFromSwymEvent(d.epi, d.empi, true);
    });
    swat.evtLayer.addEventListener('sw:removedfromwishlist', function (e) {
      var d = e && e.detail && e.detail.d ? e.detail.d : {};
      jscQvUpdateFromSwymEvent(d.epi, d.empi, false);
    });
    qvWishlistEvtBound = true;
  }

  function jscQvSyncWishlistFromSwym(swat) {
    if (!swat || typeof swat.fetchLists !== 'function') {
      return;
    }
    var root = jscQvWishlistRoot();
    if (!root) {
      return;
    }
    swat.fetchLists({
      callbackFn: function (lists) {
        var wishlistKeys = {};
        (lists || []).forEach(function (list) {
          if (!(list && (list.lty === 'wl' || list.lty === null || typeof list.lty === 'undefined'))) {
            return;
          }
          (list.listcontents || []).forEach(function (item) {
            if (item && item.epi && item.empi) {
              wishlistKeys[String(item.epi) + ':' + String(item.empi)] = true;
            }
          });
        });
        root.querySelectorAll('[data-jsc-qv-wishlist-button="true"]').forEach(function (btn) {
          var key = String(btn.dataset.variantId) + ':' + String(btn.dataset.productId);
          jscQvSetWishlistState(btn, !!wishlistKeys[key]);
        });
      },
      errorFn: function () {},
    });
  }

  function jscQvOnWishlistClick(btn) {
    var swat = window._swat;
    if (!swat) {
      return;
    }
    var productId = btn.dataset.productId;
    var variantId = btn.dataset.variantId;
    var productUrl = btn.dataset.productUrl;
    if (!productId || !variantId || !productUrl) {
      return;
    }
    jscQvSetWishlistLoading(btn, true);
    jscQvEnsureWishlistListId(swat).then(function (listId) {
      if (!listId) {
        jscQvSetWishlistLoading(btn, false);
        return;
      }
      var product = {
        empi: parseInt(productId, 10),
        epi: parseInt(variantId, 10),
        du: productUrl,
      };
      var isWishlisted = btn.dataset.jscWishlistAdded === 'true';
      function onOk() {
        jscQvSetWishlistState(btn, !isWishlisted);
        jscQvSetWishlistLoading(btn, false);
      }
      function onErr() {
        jscQvSetWishlistLoading(btn, false);
      }
      if (isWishlisted && typeof swat.deleteFromList === 'function') {
        swat.deleteFromList(listId, product, onOk, onErr);
      } else if (!isWishlisted && typeof swat.addToList === 'function') {
        swat.addToList(listId, product, onOk, onErr);
      } else {
        onErr();
      }
    });
  }

  function jscQvWishlistAfterSwymReady(swat) {
    jscQvBindSwymEvtLayer(swat);
    jscQvSyncWishlistFromSwym(swat);
  }

  var qvSwymCallbackPushed = false;
  function jscQvWishlistInitPhase() {
    if (window._swat) {
      jscQvWishlistAfterSwymReady(window._swat);
      jscQvSyncWishlistFromSwym(window._swat);
      return;
    }
    if (qvSwymCallbackPushed) {
      return;
    }
    qvSwymCallbackPushed = true;
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      jscQvWishlistAfterSwymReady(swat);
      jscQvSyncWishlistFromSwym(swat);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-jsc-qv-wishlist-button="true"]');
      if (!btn) {
        return;
      }
      var root = jscQvWishlistRoot();
      if (!root || !root.contains(btn)) {
        return;
      }
      e.preventDefault();
      jscQvOnWishlistClick(btn);
    },
    false
  );

  document.addEventListener('quick-view:open', function () {
    requestAnimationFrame(jscQvWishlistInitPhase);
  });
  document.addEventListener('jsc:product-drawer-content-updated', function () {
    requestAnimationFrame(jscQvWishlistInitPhase);
  });

  document.addEventListener('product:variant-change', function (e) {
    var d = e.detail;
    if (!d || !d.variant || !d.variant.id || !d.sectionId) {
      return;
    }
    var root = jscQvWishlistRoot();
    if (!root) {
      return;
    }
    var vs = root.querySelector('variant-selects');
    if (!vs || vs.dataset.section !== d.sectionId) {
      return;
    }
    var btn = root.querySelector('[data-jsc-qv-wishlist-button="true"]');
    if (!btn) {
      return;
    }
    btn.dataset.variantId = String(d.variant.id);
    if (window._swat) {
      jscQvSyncWishlistFromSwym(window._swat);
    }
  });
})();

/**
 * Show the merchant-designed confirmation after any successful Swym wishlist add.
 */
(function jscInitWishlistToast() {
  if (window.jscWishlistToastBound) {
    return;
  }
  window.jscWishlistToastBound = true;

  var dismissTimer = null;
  var swymEventBound = false;
  var lastShownAt = 0;

  function jscWishlistToastElement() {
    var toast = document.getElementById('jsc-wishlist-toast');
    if (toast) {
      return toast;
    }

    toast = document.createElement('div');
    toast.id = 'jsc-wishlist-toast';
    toast.className = 'jsc-wishlist-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.innerHTML =
      '<svg class="jsc-wishlist-toast__status" viewBox="0 0 16 16" aria-hidden="true">' +
        '<circle cx="8" cy="8" r="8" fill="#146b43"></circle>' +
        '<path d="m4.75 8.1 2.1 2.1 4.4-4.4" fill="none" stroke="#fff" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>' +
      '<div class="jsc-wishlist-toast__copy">' +
        '<p class="jsc-wishlist-toast__title">Item added to wishlist</p>' +
        (document.body.classList.contains('customer-logged-in')
          ? ''
          : '<p class="jsc-wishlist-toast__message">Log in or create your account so you don’t lose your wishlist.</p>') +
      '</div>' +
      '<button class="jsc-wishlist-toast__close" type="button" aria-label="Close wishlist notification">' +
        '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2 2 10" fill="none" stroke="currentColor" stroke-width="1"></path></svg>' +
      '</button>';
    document.body.appendChild(toast);

    toast.querySelector('.jsc-wishlist-toast__close').addEventListener('click', jscHideWishlistToast);
    return toast;
  }

  function jscHideWishlistToast() {
    var toast = document.getElementById('jsc-wishlist-toast');
    window.clearTimeout(dismissTimer);
    dismissTimer = null;
    if (toast) {
      toast.classList.remove('is-visible');
    }
    document.body.classList.remove('jsc-wishlist-toast-active');
  }

  function jscShowWishlistToast() {
    var toast = jscWishlistToastElement();
    var now = Date.now();
    window.clearTimeout(dismissTimer);
    document.body.classList.remove('jsc-wishlist-toast-pending');
    document.body.classList.add('jsc-wishlist-toast-active');
    if (now - lastShownAt < 500) {
      dismissTimer = window.setTimeout(jscHideWishlistToast, 5000);
      return;
    }
    lastShownAt = now;
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    dismissTimer = window.setTimeout(jscHideWishlistToast, 5000);
  }

  function jscBindWishlistToastEvent(swat) {
    if (swymEventBound || !swat || !swat.evtLayer) {
      return;
    }
    swat.evtLayer.addEventListener('sw:addedtowishlist', jscShowWishlistToast);
    swymEventBound = true;
  }

  function jscWishlistControlIsAdded(control) {
    return (
      control.getAttribute('aria-pressed') === 'true' ||
      control.dataset.jscWishlistAdded === 'true' ||
      control.classList.contains('swym-added') ||
      /^added/i.test(control.getAttribute('aria-label') || '')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      var control = event.target.closest(
        '.swym-wishlist-collections-v2, [data-jsc-qv-wishlist-button="true"], [data-jsc-cart-wishlist-button="true"], #swym-custom-wishlist-button button'
      );
      if (!control || jscWishlistControlIsAdded(control)) {
        return;
      }

      var productId = control.getAttribute('data-product-id');
      var attempts = 0;
      document.body.classList.add('jsc-wishlist-toast-pending');
      var stateTimer = window.setInterval(function () {
        var currentControl = control;
        if (!currentControl.isConnected && productId) {
          currentControl = Array.prototype.find.call(
            document.querySelectorAll('.swym-wishlist-collections-v2[data-product-id]'),
            function (candidate) {
              return candidate.getAttribute('data-product-id') === productId;
            }
          );
        }
        attempts++;
        if (currentControl && jscWishlistControlIsAdded(currentControl)) {
          window.clearInterval(stateTimer);
          jscShowWishlistToast();
        } else if (attempts >= 50) {
          window.clearInterval(stateTimer);
          document.body.classList.remove('jsc-wishlist-toast-pending');
        }
      }, 100);
    },
    true
  );

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(jscBindWishlistToastEvent);
  if (window._swat) {
    jscBindWishlistToastEvent(window._swat);
  }
})();

/**
 * Convert Swym's wishlist-page login row into the merchant message prompt.
 */
(function jscInitWishlistLoginMessage() {
  if (window.jscWishlistLoginMessageBound) {
    return;
  }
  window.jscWishlistLoginMessageBound = true;

  function jscEnhanceWishlistLoginMessage() {
    var host = document.querySelector('swym-storefront-layout-login-user');
    var container = host && host.querySelector('.swym-storefront-layout-login-user-container');
    if (!host || !container || container.dataset.jscLoginMessageReady === 'true') {
      return false;
    }

    container.dataset.jscLoginMessageReady = 'true';
    container.setAttribute('role', 'status');
    container.setAttribute('aria-label', 'Wishlist sign in reminder');

    var heading = container.querySelector('.swym-storefront-layout-login-heading');
    var description = container.querySelector('.swym-storefront-layout-login-description');
    if (heading) {
      heading.textContent = 'Don’t lose your wishlist!';
    }
    if (description) {
      description.textContent = 'Log in or create your account so you don’t lose your wishlist.';
    }

    var statusIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    statusIcon.setAttribute('class', 'jsc-wishlist-login-message__status');
    statusIcon.setAttribute('viewBox', '0 0 16 16');
    statusIcon.setAttribute('aria-hidden', 'true');
    statusIcon.innerHTML =
      '<circle cx="8" cy="8" r="8" fill="#146b43"></circle>' +
      '<path d="M8 4.3v4.1M8 11.2v.1" fill="none" stroke="#fff" stroke-width="1.25" stroke-linecap="round"></path>';
    container.insertBefore(statusIcon, container.firstChild);

    var action = document.createElement('a');
    action.className = 'jsc-wishlist-login-message__action';
    action.href = '/account/login';
    action.textContent = 'Sign in / Sign up';
    container.appendChild(action);

    var close = document.createElement('button');
    close.className = 'jsc-wishlist-login-message__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss wishlist sign in reminder');
    close.innerHTML =
      '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2 2 10" fill="none" stroke="currentColor" stroke-width="1"></path></svg>';
    close.addEventListener('click', function () {
      host.classList.add('jsc-wishlist-login-message--dismissed');
    });
    container.appendChild(close);
    return true;
  }

  if (!jscEnhanceWishlistLoginMessage()) {
    var observer = new MutationObserver(function () {
      if (jscEnhanceWishlistLoginMessage()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }
})();

/**
 * Swym storefront wishlist grid:
 * - Place `.swym-storefront-layout-grid-item-price-variant` before `.swym-storefront-layout-grid-item-title`.
 * - `.swym-storefront-layout-grid-item-final-price`: format `500.00 ฿` → `฿ 500.00` (symbol before amount).
 * - Split titles like `Name (Variant)` — name stays in `.swym-storefront-layout-grid-item-title`,
 *   variant is inserted as a sibling `.jsc-swym-grid-item-variant` right after the title node.
 * - Fetch `?view=jsc-card-siblings` per row and inject `.jsc-product-card-product-siblings` (same Liquid as collection cards).
 * - Replace kebab menu SVG on `.swym-storefront-layout-grid-item-option-button` with theme trash icon (matches cart drawer `svg-icons` trash).
 * - Replace default ATC markup on `.swym-storefront-layout-grid-item-add-to-cart-button` with theme cart indicator SVG (Files asset).
 * - Move ATC into `.swym-storefront-layout-grid-item-image-container` (bottom-right overlay); keep it outside product `<a>` when possible so image clicks still navigate.
 * - When the image sits inside `<a href="/products/...">`, bubble-phase guard cancels link navigation only for clicks that hit the ATC control.
 * - After cart API success: re-render drawer from `theme.routes.cart_url?sections=…` (do not dispatch `cart:refresh` here — avoids CartDrawer double-fetch loops). `fetch`/`XHR` hooks only (no DOM toast observer — it retriggered forever).
 * - Keep option button out of the image block (move back into `.swym-storefront-layout-grid-item-action-container` if needed).
 */
(function jscSwymStorefrontGridPriceBeforeTitle() {
  if (window.jscSwymStorefrontGridPriceReorderBound) {
    return;
  }
  window.jscSwymStorefrontGridPriceReorderBound = true;

  var reorderTid = null;

  /** Wishlist template `/sections` request can differ from `/cart`; Swym also completes ATC asynchronously — hook cart endpoints + Swym toast. */
  function jscWishlistCartDrawer_sectionInner(html, selector) {
    if (!html) {
      return '';
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function jscWishlistCartDrawer_applyFlatSections(parsedState) {
    if (!parsedState) {
      return;
    }
    var map = [
      { id: 'Cart-Drawer', key: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', key: 'cart-bubble', selector: '.thb-item-count' }
    ];
    for (var i = 0; i < map.length; i++) {
      var m = map[i];
      var block = parsedState[m.key];
      if (!block) {
        continue;
      }
      var inner = jscWishlistCartDrawer_sectionInner(block, m.selector);
      if (!inner) {
        continue;
      }
      var host = document.getElementById(m.id);
      if (!host) {
        continue;
      }
      var el = host.querySelector(m.selector) || host;
      el.innerHTML = inner;
    }
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      if (typeof drawer.removeProductEvent === 'function') {
        drawer.removeProductEvent();
      }
      if (typeof drawer.notesToggle === 'function') {
        drawer.notesToggle();
      }
      if (typeof drawer.initializeWishlistButtons === 'function') {
        drawer.initializeWishlistButtons();
      }
    }
  }

  function jscWishlistCartDrawer_cartPageBasePath() {
    var u = window.theme && theme.routes && theme.routes.cart_url;
    return u ? String(u).split('?')[0] : '/cart';
  }

  var jscWishlistCartDrawer_lastApplyMs = 0;
  function jscWishlistCartDrawer_refreshFromCartPage(opts) {
    var now = Date.now();
    if (!opts || !opts.force) {
      if (now - jscWishlistCartDrawer_lastApplyMs < 900) {
        return Promise.resolve();
      }
    }
    var sections = 'cart-drawer,cart-bubble';
    var url = jscWishlistCartDrawer_cartPageBasePath() + '?sections=' + encodeURIComponent(sections);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json, text/javascript, */*' } })
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        jscWishlistCartDrawer_lastApplyMs = Date.now();
        var parsedState = JSON.parse(text);
        jscWishlistCartDrawer_applyFlatSections(parsedState);
        /* Do not dispatch `cart:refresh` here — CartDrawer listens and would fetch again (loop + duplicate work). */
        try {
          document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
        } catch (e) {}
        if (opts && opts.openDrawer) {
          var dr = document.getElementById('Cart-Drawer');
          if (dr && typeof dr.open === 'function') {
            dr.open();
          }
        }
      })
      .catch(function () {});
  }

  var jscWishlistCartDrawer_syncTid = null;
  function jscWishlistCartDrawer_onSwymGridPage() {
    return !!(
      document.getElementById('swym-storefront-layout-section-container') ||
      document.querySelector('.swym-storefront-layout-tab-container .swym-storefront-layout-grid-item')
    );
  }

  function jscWishlistCartDrawer_debouncedSync(openDrawer) {
    if (jscWishlistCartDrawer_syncTid) {
      clearTimeout(jscWishlistCartDrawer_syncTid);
    }
    jscWishlistCartDrawer_syncTid = setTimeout(function () {
      jscWishlistCartDrawer_syncTid = null;
      jscWishlistCartDrawer_refreshFromCartPage({ openDrawer: !!openDrawer });
    }, 160);
  }

  function jscWishlistCartDrawer_tryNotifyCartAddJson(bodyText) {
    if (!bodyText || typeof bodyText !== 'string') {
      return;
    }
    try {
      var j = JSON.parse(bodyText);
      if (j && (j.status === 422 || j.status === '422')) {
        return;
      }
      if (j && typeof j.status === 'number' && j.status >= 400) {
        return;
      }
      jscWishlistCartDrawer_debouncedSync(jscWishlistCartDrawer_onSwymGridPage());
    } catch (e) {}
  }

  if (!window.jscWishlistCartHooksInstalled) {
    window.jscWishlistCartHooksInstalled = true;
    var _jscOrigFetch = window.fetch;
    window.fetch = function () {
      var fetchArgs = arguments;
      return _jscOrigFetch.apply(window, fetchArgs).then(function (res) {
        try {
          var req = fetchArgs[0];
          var urlStr =
            typeof req === 'string'
              ? req
              : req && typeof req.url === 'string'
                ? req.url
                : '';
          if (!res || !res.ok || !urlStr) {
            return res;
          }
          var u = urlStr.split('#')[0];
          if (!/\/cart\/(add|change|update)/i.test(u)) {
            return res;
          }
          var ct = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
          if (res.clone && ct.indexOf('application/json') !== -1) {
            res
              .clone()
              .text()
              .then(function (txt) {
                jscWishlistCartDrawer_tryNotifyCartAddJson(txt);
              })
              .catch(function () {});
          } else {
            jscWishlistCartDrawer_debouncedSync(jscWishlistCartDrawer_onSwymGridPage());
          }
        } catch (e2) {}
        return res;
      });
    };

    var _xo = XMLHttpRequest.prototype.open;
    var _xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.jscSwymCartXhrUrl = url;
      return _xo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;
      xhr.addEventListener(
        'load',
        function () {
          try {
            var u = String(xhr.jscSwymCartXhrUrl || '');
            if (!xhr.status || xhr.status < 200 || xhr.status >= 300) {
              return;
            }
            if (!/\/cart\/(add|change|update)/i.test(u)) {
              return;
            }
            var ct = xhr.getResponseHeader && xhr.getResponseHeader('Content-Type');
            if (ct && ct.indexOf('application/json') !== -1 && xhr.responseText) {
              jscWishlistCartDrawer_tryNotifyCartAddJson(xhr.responseText);
            } else {
              jscWishlistCartDrawer_debouncedSync(jscWishlistCartDrawer_onSwymGridPage());
            }
          } catch (e3) {}
        },
        false
      );
      return _xs.apply(this, arguments);
    };
  }

  function jscReorderSwymGridPriceBeforeTitle() {
    document.querySelectorAll('.swym-storefront-layout-grid-item-content').forEach(function (content) {
      var price = content.querySelector('.swym-storefront-layout-grid-item-price-variant');
      var title = content.querySelector('.swym-storefront-layout-grid-item-title');
      if (!price || !title || !title.parentNode) {
        return;
      }
      var priceAfterTitle = title.compareDocumentPosition(price) & Node.DOCUMENT_POSITION_FOLLOWING;
      if (priceAfterTitle) {
        title.parentNode.insertBefore(price, title);
      }
    });
  }

  /** Desktop 4-col grid: Swym often sets inline flex on the items container; reinforce with important styles. */
  function jscApplySwymWishlistItemsGridDesktop() {
    var mq = window.matchMedia('(min-width: 1025px)');
    var gapPx =
      (typeof getComputedStyle === 'function' &&
        getComputedStyle(document.documentElement).getPropertyValue('--column-gap').trim()) ||
      '16px';
    var sel =
      '#swym-storefront-layout-section-container .swym-storefront-layout-items-container, ' +
      '.swym-storefront-layout-tab-container .swym-storefront-layout-items-container, ' +
      '.swym-wishlist-collections-v2-container .swym-storefront-layout-items-container, ' +
      '.swym-storefront-layout-items-container';
    document.querySelectorAll(sel).forEach(function (el) {
      if (!el || !el.style) {
        return;
      }
      if (mq.matches) {
        el.style.setProperty('display', 'grid', 'important');
        el.style.setProperty('grid-template-columns', 'repeat(4, minmax(0, 1fr))', 'important');
        el.style.setProperty('grid-auto-flow', 'row', 'important');
        el.style.setProperty('gap', gapPx, 'important');
        el.style.setProperty('align-items', 'stretch', 'important');
        el.style.setProperty('flex-wrap', 'unset', 'important');
        for (var c = el.firstElementChild; c; c = c.nextElementSibling) {
          c.style.setProperty('min-width', '0', 'important');
          c.style.setProperty('width', 'auto', 'important');
          c.style.setProperty('max-width', 'none', 'important');
          c.style.setProperty('flex', 'none', 'important');
          c.style.setProperty('flex-basis', 'auto', 'important');
        }
      } else {
        [
          'display',
          'grid-template-columns',
          'grid-auto-flow',
          'gap',
          'align-items',
          'flex-wrap',
        ].forEach(function (p) {
          el.style.removeProperty(p);
        });
        for (var ch = el.firstElementChild; ch; ch = ch.nextElementSibling) {
          ['min-width', 'width', 'max-width', 'flex', 'flex-basis'].forEach(function (p) {
            ch.style.removeProperty(p);
          });
        }
      }
    });
  }

  /** Return option/trash control to Swym’s action row (not over the product image). */
  function jscRestoreSwymOptionButtonOutsideImage() {
    document.querySelectorAll('.swym-storefront-layout-grid-item-content').forEach(function (content) {
      var root = content.closest('.swym-storefront-layout-grid-item');
      var imgWrap =
        content.querySelector('.swym-storefront-layout-grid-item-image-container') ||
        (root && root.querySelector('.swym-storefront-layout-grid-item-image-container'));
      var btn =
        content.querySelector('.swym-storefront-layout-grid-item-option-button') ||
        (root && root.querySelector('.swym-storefront-layout-grid-item-option-button'));
      if (!btn || !imgWrap || !imgWrap.contains(btn)) {
        return;
      }
      var actions =
        content.querySelector('.swym-storefront-layout-grid-item-action-container') ||
        (root && root.querySelector('.swym-storefront-layout-grid-item-action-container'));
      if (actions) {
        actions.appendChild(btn);
        return;
      }
      if (imgWrap.parentNode) {
        imgWrap.parentNode.insertBefore(btn, imgWrap.nextSibling);
      }
    });
  }

  /**
   * Wishlist grid ATC sits over the image (CSS positions bottom-right). Ensure DOM sits outside the product link
   * when Swym wraps the image in `<a href="/products/...">` so link navigation and ATC stay independent.
   */
  function jscMoveSwymAddToCartOntoProductImage() {
    if (window.theme && theme.settings && theme.settings.hide_atc_button) {
      return;
    }
    document.querySelectorAll('.swym-storefront-layout-grid-item-add-to-cart-button').forEach(function (btn) {
      var root = btn.closest('.swym-storefront-layout-grid-item');
      var imgWrap =
        (root && root.querySelector('.swym-storefront-layout-grid-item-image-container')) ||
        btn.closest('.swym-storefront-layout-grid-item-image-container');
      if (!imgWrap) {
        return;
      }
      var productLink = imgWrap.querySelector('a[href*="/products/"]');
      if (productLink && productLink !== btn && productLink.contains(btn)) {
        if (productLink.parentNode) {
          productLink.parentNode.insertBefore(btn, productLink.nextSibling);
        }
      }
      if (btn.parentElement !== imgWrap) {
        imgWrap.appendChild(btn);
      }
      btn.setAttribute('data-jsc-swym-atc-on-image', 'true');
      jscGuardSwymWishlistImageAnchorForAtc(imgWrap);
    });
  }

  /**
   * When the image block is wrapped in `<a href="/products/...">`, ATC may sit inside that anchor.
   * Bubble phase runs after Swym’s handlers on the button; cancel only navigation, not other bubbling needs.
   */
  function jscGuardSwymWishlistImageAnchorForAtc(imgWrap) {
    var wrapLink = imgWrap.closest('a[href*="/products/"]');
    if (!wrapLink || !wrapLink.contains(imgWrap)) {
      return;
    }
    if (wrapLink.getAttribute('data-jsc-swym-atc-link-guard') === 'true') {
      return;
    }
    wrapLink.setAttribute('data-jsc-swym-atc-link-guard', 'true');
    function guardClick(e) {
      var t = e.target;
      var atc =
        t && typeof t.closest === 'function'
          ? t.closest('.swym-storefront-layout-grid-item-add-to-cart-button')
          : null;
      if (atc && wrapLink.contains(atc)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    wrapLink.addEventListener('click', guardClick, false);
  }

  /** Trash paths match `svg-icons` → `trash`; stroke `#3d3d3d` for wishlist (cart drawer keeps red in Liquid). */
  function jscReplaceSwymWishlistOptionIconWithTrash() {
    var trashPathMarker = '11.0002 3V12.5';
    var trashSvg =
      '<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M12 3L1 3M5.00024 6V10M8.00024 6V10M11.0002 3V12.5C11.0002 12.6326 10.9476 12.7598 10.8538 12.8536C10.76 12.9473 10.6329 13 10.5002 13H2.50024C2.36764 13 2.24046 12.9473 2.14669 12.8536C2.05292 12.7598 2.00024 12.6326 2.00024 12.5V3M9.00025 3V2C9.00025 1.73478 8.89489 1.48043 8.70735 1.29289C8.51982 1.10536 8.26546 1 8.00024 1H5.00024C4.73503 1 4.48067 1.10536 4.29314 1.29289C4.1056 1.48043 4.00024 1.73478 4.00024 2V3" stroke="#3d3d3d" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    document.querySelectorAll('.swym-storefront-layout-grid-item-option-button').forEach(function (btn) {
      var path = btn.querySelector('path');
      var d = path && path.getAttribute('d');
      var stroke = path && path.getAttribute('stroke');
      var strokeLc = stroke ? String(stroke).toLowerCase() : '';
      if (d && d.indexOf(trashPathMarker) !== -1 && strokeLc === '#3d3d3d') {
        btn.setAttribute('data-jsc-trash-icon', 'true');
        return;
      }
      btn.setAttribute('data-jsc-trash-icon', 'true');
      btn.innerHTML = trashSvg;
    });
  }

  var JSC_SWYM_ATC_ICON_SRC =
    'https://cdn.shopify.com/s/files/1/0736/3061/3700/files/Cart-item-indicator.svg?v=1778056471';

  function jscSwymWishlistAtcIconIsClean(btn) {
    var imgs = btn.querySelectorAll('.jsc-swym-atc-icon');
    if (imgs.length !== 1 || imgs[0].getAttribute('src') !== JSC_SWYM_ATC_ICON_SRC) {
      return false;
    }
    for (var c = btn.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3 && String(c.textContent).replace(/\s/g, '') !== '') {
        return false;
      }
      if (c.nodeType === 1 && !c.classList.contains('jsc-swym-atc-icon')) {
        return false;
      }
    }
    return true;
  }

  /** Single img matching Lacoste wishlist-grid ATC treatment; Swym may re-render — replace each pass. */
  function jscReplaceSwymWishlistAddToCartIcon() {
    var hideAtc = window.theme && theme.settings && theme.settings.hide_atc_button;
    document.querySelectorAll('.swym-storefront-layout-grid-item-add-to-cart-button').forEach(function (btn) {
      if (hideAtc) {
        btn.setAttribute('hidden', 'hidden');
        btn.setAttribute('aria-hidden', 'true');
        btn.style.display = 'none';
        btn.style.pointerEvents = 'none';
        if (btn.getAttribute('data-jsc-swym-atc-blocked') !== 'true') {
          btn.setAttribute('data-jsc-swym-atc-blocked', 'true');
          btn.addEventListener(
            'click',
            function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return false;
            },
            true
          );
        }
        return;
      }
      btn.setAttribute('data-jsc-swym-atc-icon', 'true');
      if (jscSwymWishlistAtcIconIsClean(btn)) {
        return;
      }
      btn.innerHTML =
        '<img class="jsc-swym-atc-icon" src="' +
        JSC_SWYM_ATC_ICON_SRC +
        '" alt="" width="40" height="40" decoding="async" draggable="false" />';
    });
  }

  /** Swym renders baht as `500.00 ฿`; move symbol before the amount. */
  function jscSwymGridFinalPriceCurrencyFirst() {
    document.querySelectorAll('.swym-storefront-layout-grid-item-final-price').forEach(function (el) {
      var raw = el.textContent.replace(/\s+/g, ' ').trim();
      var m = raw.match(/^([\d.,]+)\s*฿$/);
      if (m) {
        el.textContent = '฿ ' + m[1];
      }
    });
  }

  /**
   * "Name (Variant)" → name only inside `.swym-storefront-layout-grid-item-title`;
   * variant value in a following sibling `.jsc-swym-grid-item-variant` (outside the title node).
   * Keeps a sole direct &lt;a&gt; around the name when Swym uses a product link.
   */
  function jscSplitSwymGridItemTitles() {
    document.querySelectorAll('.swym-storefront-layout-grid-item-content').forEach(function (content) {
      var title = content.querySelector('.swym-storefront-layout-grid-item-title');
      if (!title) {
        return;
      }
      var raw = title.textContent.replace(/\s+/g, ' ').trim();
      var m = raw.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
      if (!m) {
        return;
      }
      var nxt = title.nextElementSibling;
      if (
        nxt &&
        nxt.classList.contains('jsc-swym-grid-item-variant') &&
        nxt.getAttribute('data-jsc-swym-split') === 'true'
      ) {
        nxt.remove();
      }
      var main = m[1].trim();
      var variant = m[2].trim();
      var anchor = title.querySelector(':scope > a');
      var singleAnchor =
        anchor &&
        title.childElementCount === 1 &&
        anchor.textContent.replace(/\s+/g, ' ').trim() === raw;

      while (title.firstChild) {
        title.removeChild(title.firstChild);
      }

      if (singleAnchor) {
        var a = document.createElement('a');
        for (var ai = 0; ai < anchor.attributes.length; ai++) {
          var attr = anchor.attributes[ai];
          a.setAttribute(attr.name, attr.value);
        }
        a.textContent = main;
        title.appendChild(a);
      } else {
        title.textContent = main;
      }

      var variantEl = document.createElement('span');
      variantEl.className = 'jsc-swym-grid-item-variant';
      variantEl.setAttribute('data-jsc-swym-split', 'true');
      variantEl.textContent = variant;
      title.parentNode.insertBefore(variantEl, title.nextSibling);
    });
  }

  function jscWlCardProductHandle(content) {
    var lk = content.querySelector('a[href*="/products/"]');
    if (!lk || !lk.getAttribute('href')) {
      return '';
    }
    try {
      var u = new URL(lk.getAttribute('href'), window.location.href);
      var pm = u.pathname.match(/\/products\/([^/]+)/);
      return pm ? decodeURIComponent(pm[1]) : '';
    } catch (e) {
      return '';
    }
  }

  /** Insert sibling swatches before `.jsc-swym-grid-item-variant`, else right after the title node. */
  function jscWlInsertSiblingsMount(content, clone) {
    var variantEl = content.querySelector('.jsc-swym-grid-item-variant[data-jsc-swym-split="true"]');
    if (variantEl && variantEl.parentNode) {
      variantEl.parentNode.insertBefore(clone, variantEl);
      return;
    }
    var titleEl = content.querySelector('.swym-storefront-layout-grid-item-title');
    if (titleEl && titleEl.parentNode) {
      var tParent = titleEl.parentNode;
      if (titleEl.nextSibling) {
        tParent.insertBefore(clone, titleEl.nextSibling);
      } else {
        tParent.appendChild(clone);
      }
      return;
    }
    content.appendChild(clone);
  }

  function jscStyleWishlistCardsAsCollectionCards() {
    document.querySelectorAll('.swym-storefront-layout-grid-item').forEach(function (card) {
      card.classList.add('jsc-wishlist-product-card');
      var content = card.querySelector('.swym-storefront-layout-grid-item-content');
      if (content) {
        content.classList.add('product-card-info', 'general-prod-card-info');
      }

      var imageLabels = card.querySelector('.lacoste-product-indicators--image');
      var imageContainer = card.querySelector('.swym-storefront-layout-grid-item-image-container');
      if (imageLabels && imageContainer && imageLabels.parentElement !== imageContainer) {
        imageContainer.appendChild(imageLabels);
      }

      var belowLabels = card.querySelector('.lacoste-product-indicators--below-swatches');
      var variant = card.querySelector('.jsc-swym-grid-item-variant');
      if (belowLabels && variant && belowLabels.previousElementSibling !== variant) {
        variant.insertAdjacentElement('afterend', belowLabels);
      }

      var actions = card.querySelector('.swym-storefront-layout-grid-item-action-container');
      if (actions) {
        actions.classList.toggle(
          'jsc-wishlist-action-empty',
          !actions.querySelector('button, a, input, select') && !actions.textContent.trim()
        );
      }
    });
  }

  function jscRenderWishlistViewedCount() {
    var list = document.querySelector('.swym-storefront-layout-default-list-container');
    if (!list) {
      return;
    }

    var viewed = list.querySelectorAll(
      '.swym-storefront-layout-items-container > swym-storefront-layout-item'
    ).length;
    var totalText = (
      document.querySelector('.swym-storefront-layout-total-list-items-count') || {}
    ).textContent || '';
    var totalMatch = totalText.match(/\d+/);
    var total = totalMatch ? parseInt(totalMatch[0], 10) : viewed;
    total = Math.max(total || 0, viewed);

    var section = document.getElementById('jsc-wishlist-viewed-count');
    if (!viewed) {
      if (section) {
        section.remove();
      }
      return;
    }

    if (!section) {
      section = document.createElement('div');
      section.id = 'jsc-wishlist-viewed-count';
      section.className = 'jsc-wishlist-viewed-count';
      section.innerHTML =
        '<p class="jsc-wishlist-viewed-count__text"></p>' +
        '<div class="jsc-wishlist-viewed-count__track" role="progressbar">' +
          '<span class="jsc-wishlist-viewed-count__bar"></span>' +
        '</div>';
    }

    var noun = viewed === 1 ? 'product' : 'products';
    section.querySelector('.jsc-wishlist-viewed-count__text').textContent =
      viewed + ' ' + noun + ' viewed on ' + total;

    var progress = section.querySelector('.jsc-wishlist-viewed-count__track');
    var percentage = total ? Math.min(100, (viewed / total) * 100) : 0;
    progress.setAttribute('aria-label', viewed + ' of ' + total + ' wishlist products viewed');
    progress.setAttribute('aria-valuemin', '0');
    progress.setAttribute('aria-valuemax', String(total));
    progress.setAttribute('aria-valuenow', String(viewed));
    section.querySelector('.jsc-wishlist-viewed-count__bar').style.width = percentage + '%';

    if (section.previousElementSibling !== list) {
      list.insertAdjacentElement('afterend', section);
    }
  }

  function jscInjectWishlistCardSiblings() {
    document.querySelectorAll('.swym-storefront-layout-grid-item-content').forEach(function (content) {
      var handle = jscWlCardProductHandle(content);
      if (!handle) {
        return;
      }

      var mountSel = '.jsc-product-card-product-siblings[data-jsc-wl-siblings-mount]';
      var mount = content.querySelector(mountSel);
      if (mount && mount.getAttribute('data-product-handle') === handle) {
        jscWlInsertSiblingsMount(content, mount);
        return;
      }
      if (mount) {
        mount.remove();
      }

      if (content.getAttribute('data-jsc-wl-siblings-empty') === handle) {
        return;
      }
      if (content.getAttribute('data-jsc-wl-siblings-failed') === handle) {
        return;
      }
      if (content.getAttribute('data-jsc-wl-siblings-loading') === handle) {
        return;
      }

      var link = content.querySelector('a[href*="/products/"]');
      var productUrl;
      try {
        productUrl = new URL(link.getAttribute('href'), window.location.href);
      } catch (e) {
        return;
      }
      productUrl.searchParams.set('view', 'jsc-card-siblings');
      var fetchUrl = productUrl.toString();

      content.setAttribute('data-jsc-wl-siblings-loading', handle);

      fetch(fetchUrl, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('jsc-card-siblings');
          }
          return res.text();
        })
        .then(function (html) {
          if (!content.isConnected || jscWlCardProductHandle(content) !== handle) {
            return;
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frag = doc.querySelector('[data-jsc-wl-siblings-fragment]');
          if (!frag || !frag.innerHTML.trim()) {
            content.setAttribute('data-jsc-wl-siblings-empty', handle);
            return;
          }
          var old = content.querySelector(mountSel);
          if (old) {
            old.remove();
          }
          var clone = frag.cloneNode(true);
          clone.setAttribute('data-jsc-wl-siblings-mount', 'true');
          clone.setAttribute('data-product-handle', handle);
          clone.removeAttribute('data-jsc-wl-siblings-fragment');
          jscWlInsertSiblingsMount(content, clone);
          jscStyleWishlistCardsAsCollectionCards();
          content.removeAttribute('data-jsc-wl-siblings-empty');
          content.removeAttribute('data-jsc-wl-siblings-failed');
        })
        .catch(function () {
          if (content.isConnected) {
            content.setAttribute('data-jsc-wl-siblings-failed', handle);
          }
        })
        .finally(function () {
          if (content.isConnected) {
            content.removeAttribute('data-jsc-wl-siblings-loading');
          }
        });
    });
  }

  function jscImplementRemoveAllWishlist() {
    var header = document.querySelector('.swym-storefront-layout-header');
    if (!header) return;

    var bannerWrapper = document.getElementById('jsc-wishlist-banner-wrapper');
    var enableRemoveAll = bannerWrapper ? bannerWrapper.getAttribute('data-enable-remove-all') === 'true' : true;
    var showItemCount = bannerWrapper ? bannerWrapper.getAttribute('data-show-item-count') !== 'false' : true;
    var bannerContent = document.getElementById('jsc-wishlist-banner-content');
    var headingWrap = bannerContent ? bannerContent.querySelector('.jsc-wishlist-banner__heading-wrap') : null;

    var originalBtn = document.getElementById('swym-storefront-layout-collection-option-button');
    if (originalBtn) {
      originalBtn.style.display = 'none';
    }

    var swymTitle = document.querySelector('.swym-storefront-layout-title');
    if (swymTitle) {
      swymTitle.style.display = 'none';
    }

    var itemCount = document.querySelector('.swym-storefront-layout-total-list-items-count');
    if (showItemCount && headingWrap && itemCount && itemCount.parentNode !== headingWrap) {
      headingWrap.appendChild(itemCount);
    } else if (!showItemCount && itemCount) {
      itemCount.style.display = 'none';
    }

    var customBtn = document.getElementById('jsc-custom-remove-all-btn');

    if (!enableRemoveAll) {
      if (customBtn) customBtn.remove();
      return; 
    }
    
    if (!customBtn) {
      var trashSvg = '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="white"/><rect x="0.5" y="0.5" width="43" height="43" rx="21.5" stroke="#082415"/><path d="M30.5 14H26.5V13.5C26.5 12.675 25.825 12 25 12H19C18.175 12 17.5 12.675 17.5 13.5V14H13.5C13.225 14 13 14.225 13 14.5C13 14.775 13.225 15 13.5 15H14.03L14.89 29.645C14.97 30.965 16.065 32 17.385 32H26.615C27.935 32 29.035 30.965 29.11 29.645L29.97 15H30.5C30.775 15 31 14.775 31 14.5C31 14.225 30.775 14 30.5 14ZM19 13H25C25.275 13 25.5 13.225 25.5 13.5V14H18.5V13.5C18.5 13.225 18.725 13 19 13ZM28.11 29.59C28.065 30.38 27.405 31 26.61 31H17.385C16.59 31 15.935 30.38 15.885 29.59L15.03 15H28.97L28.11 29.59ZM22.5 17.5V28.5C22.5 28.775 22.275 29 22 29C21.725 29 21.5 28.775 21.5 28.5V17.5C21.5 17.225 21.725 17 22 17C22.275 17 22.5 17.225 22.5 17.5ZM26.02 17C26.295 17.01 26.51 17.245 26.495 17.52L25.995 28.52C25.985 28.79 25.765 29 25.5 29C25.49 29 25.485 29 25.475 29C25.2 28.985 24.985 28.755 25 28.48L25.5 17.48C25.515 17.2 25.765 16.995 26.02 17ZM18.5 17.475L19 28.475C19.01 28.75 18.8 28.985 18.525 28.995C18.515 28.995 18.51 28.995 18.5 28.995C18.235 28.995 18.015 28.785 18 28.515L17.5 17.515C17.49 17.24 17.7 17.005 17.975 16.995C18.255 16.995 18.485 17.2 18.5 17.475Z" fill="#082415"/></svg>';

      customBtn = document.createElement('button');
      customBtn.id = 'jsc-custom-remove-all-btn';
      customBtn.className = 'swym-storefront-layout-collection-option-button swym-single-share-wishlist-btn';
      customBtn.innerHTML = trashSvg;
      customBtn.setAttribute('aria-label', 'Remove all items');
      
      if (bannerContent) {
        bannerContent.appendChild(customBtn);
      } else {
        header.appendChild(customBtn);
      }

      customBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (customBtn.classList.contains('jsc-btn-disabled')) return;

        var swat = window._swat;
        if (!swat) return;

        customBtn.style.opacity = '0.5';
        customBtn.style.pointerEvents = 'none';

        swat.fetchLists({
          callbackFn: function(lists) {
            var wishlist = (lists || []).find(function(list) {
              return list && (list.lty === 'wl' || list.lty === null || typeof list.lty === 'undefined');
            });

            if (wishlist && wishlist.lid) {
              swat.deleteList(wishlist.lid, 
                function() { 
                  customBtn.style.opacity = ''; 
                  customBtn.style.pointerEvents = ''; 
                  customBtn.classList.add('jsc-btn-disabled');

                  document.querySelectorAll('.swym-storefront-layout-grid-item').forEach(function(item) { 
                    item.remove(); 
                  });

                  var countText = document.querySelector('.swym-storefront-layout-total-list-items-count');
                  if (countText) countText.textContent = '0 items';

                  if (typeof swat.fetchWl === 'function') {
                    swat.fetchWl();
                  } else if (swat.ui && typeof swat.ui.render === 'function') {
                    swat.ui.render();
                  } else {
                    window.location.reload(); 
                  }
                }, 
                function() { 
                  console.error('[jsc] Failed to delete wishlist');
                  customBtn.style.opacity = '';
                  customBtn.style.pointerEvents = '';
                }
              );
            } else {
              customBtn.style.opacity = '';
              customBtn.style.pointerEvents = '';
            }
          },
          errorFn: function() {
            console.error('[jsc] Failed to fetch lists');
            customBtn.style.opacity = '';
            customBtn.style.pointerEvents = '';
          }
        });
      });
    } else if (bannerContent && customBtn.parentNode !== bannerContent) {
      bannerContent.appendChild(customBtn);
    }

    // Dynamic Check for Empty State
    var isSwymEmpty = true;
    var gridItems = document.querySelectorAll('.swym-storefront-layout-grid-item');
    
    for (var i = 0; i < gridItems.length; i++) {
      var item = gridItems[i];
      if (item.classList.contains('swym-hidden') || item.style.display === 'none') continue;
      
      var link = item.querySelector('a[href*="/products/"]');
      if (link && item.offsetWidth > 0) {
        isSwymEmpty = false;
        break;
      }
    }

    if (isSwymEmpty) {
      customBtn.classList.add('jsc-btn-disabled');
    } else {
      customBtn.classList.remove('jsc-btn-disabled');
    }
  }

  function scheduleReorder() {
    if (reorderTid) {
      clearTimeout(reorderTid);
    }
    reorderTid = setTimeout(function () {
      reorderTid = null;
      jscReorderSwymGridPriceBeforeTitle();
      jscSwymGridFinalPriceCurrencyFirst();
      jscApplySwymWishlistItemsGridDesktop();
      jscRestoreSwymOptionButtonOutsideImage();
      jscReplaceSwymWishlistOptionIconWithTrash();
      jscReplaceSwymWishlistAddToCartIcon();
      jscMoveSwymAddToCartOntoProductImage();
      jscSplitSwymGridItemTitles();
      jscInjectWishlistCardSiblings();
      jscStyleWishlistCardsAsCollectionCards();
      jscRenderWishlistViewedCount();
      jscImplementRemoveAllWishlist();
    }, 50);
  }

  function mutationMightAffectSwymGrid(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type !== 'childList') {
        continue;
      }
      var parentEl = m.target && m.target.nodeType === 1 ? m.target : null;
      /*
       * Must react to Swym rewriting the ATC button on click (loading / added copy); otherwise the icon is never
       * re-injected and CSS (`font-size: 0`) leaves an empty-looking control. Idempotent `jscReplaceSwymWishlistAddToCartIcon`
       * skips DOM writes when our img is already in place, so we do not re-trigger flicker loops.
       */
      if (
        parentEl &&
        parentEl.classList &&
        parentEl.classList.contains('swym-storefront-layout-grid-item-add-to-cart-button')
      ) {
        return true;
      }
      if (parentEl && parentEl.closest && parentEl.closest('.swym-storefront-layout-grid-item-add-to-cart-button')) {
        return true;
      }
      var lists = [m.addedNodes, m.removedNodes];
      for (var li = 0; li < lists.length; li++) {
        var nodes = lists[li];
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) {
            continue;
          }
          var cls = n.classList;
          if (
            (cls && cls.contains('swym-storefront-layout-grid-item-content')) ||
            (cls && cls.contains('swym-storefront-layout-grid-item-title')) ||
            (cls && cls.contains('swym-storefront-layout-items-container')) ||
            (cls && cls.contains('swym-storefront-layout-grid-item-option-button')) ||
            (cls && cls.contains('swym-storefront-layout-grid-item-add-to-cart-button')) ||
            (cls && cls.contains('swym-storefront-layout-grid-item-image-container')) ||
            (typeof n.querySelector === 'function' &&
              (n.querySelector('.swym-storefront-layout-grid-item-content') ||
                n.querySelector('.swym-storefront-layout-grid-item-title') ||
                n.querySelector('.swym-storefront-layout-items-container') ||
                n.querySelector('.swym-storefront-layout-grid-item-option-button') ||
                n.querySelector('.swym-storefront-layout-grid-item-add-to-cart-button') ||
                n.querySelector('.swym-storefront-layout-grid-item-image-container')))
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }

  var jscSwymAtcFollowUpTid = null;
  function jscScheduleSwymWishlistAtcIconFollowUps() {
    if (jscSwymAtcFollowUpTid) {
      clearTimeout(jscSwymAtcFollowUpTid);
    }
    jscSwymAtcFollowUpTid = setTimeout(function () {
      jscSwymAtcFollowUpTid = null;
      scheduleReorder();
    }, 200);
    setTimeout(scheduleReorder, 500);
  }

  /** Last-resort sync if network hooks miss (loads from `/cart?sections=` — not wishlist pathname). */
  function jscNotifyCartUiAfterSwymWishlistAtc() {
    setTimeout(function () {
      jscWishlistCartDrawer_refreshFromCartPage({ openDrawer: false });
    }, 1100);
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (t && typeof t.closest === 'function' && t.closest('.swym-storefront-layout-grid-item-add-to-cart-button')) {
        jscScheduleSwymWishlistAtcIconFollowUps();
        jscNotifyCartUiAfterSwymWishlistAtc();
      }
    },
    false
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReorder);
  } else {
    scheduleReorder();
  }

  var mo = new MutationObserver(function (mutations) {
    if (mutationMightAffectSwymGrid(mutations)) {
      scheduleReorder();
    }
  });
  var jscSwymGridMoOpts = {
    childList: true,
    subtree: true,
  };
  if (document.body) {
    mo.observe(document.body, jscSwymGridMoOpts);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.body) {
        mo.observe(document.body, jscSwymGridMoOpts);
      }
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    scheduleReorder();
  });
  if (window._swat) {
    scheduleReorder();
  }

  var jscWlGridDesktopMm = window.matchMedia('(min-width: 1025px)');
  function jscWlGridDesktopOnChange() {
    scheduleReorder();
  }
  if (jscWlGridDesktopMm.addEventListener) {
    jscWlGridDesktopMm.addEventListener('change', jscWlGridDesktopOnChange);
  } else if (jscWlGridDesktopMm.addListener) {
    jscWlGridDesktopMm.addListener(jscWlGridDesktopOnChange);
  }
})();

/**
 * Swym attaches its header icon next to the element matched by the placement selector
 * configured in the app embed. When that selector misses — e.g. it pins `a[href='/cart']`
 * while a localized page renders `/en/cart` — the icon is left inside the app block at the
 * end of <body> and shows up under the footer. Move it into the header icon row.
 */
(function jscInitSwymHeaderIconPlacement() {
  if (window.jscSwymHeaderIconPlacementBound) {
    return;
  }
  window.jscSwymHeaderIconPlacementBound = true;

  function jscPlaceSwymHeaderIcon() {
    var icon = document.getElementById('swym-advanced-header-icon');
    if (!icon) {
      return;
    }
    var area = document.querySelector('.header .header--inner .thb-secondary-area');
    if (!area || area.contains(icon)) {
      return;
    }
    // Flex `order` decides the visual slot, so any position inside the row works.
    var anchor = area.querySelector('.thb-secondary-wishlist') || area.querySelector('.jsc-section-divider');
    area.insertBefore(icon, anchor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', jscPlaceSwymHeaderIcon);
  } else {
    jscPlaceSwymHeaderIcon();
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(jscPlaceSwymHeaderIcon);

  var jscSwymHeaderIconMo = new MutationObserver(jscPlaceSwymHeaderIcon);
  function jscObserveSwymHeaderIcon() {
    if (document.body) {
      jscSwymHeaderIconMo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.body) {
    jscObserveSwymHeaderIcon();
  } else {
    document.addEventListener('DOMContentLoaded', jscObserveSwymHeaderIcon);
  }
})();